

// // // // // import React, { useState, useEffect } from 'react';
// // // // // import { useNavigate } from 'react-router-dom';
// // // // // import { useFormik } from 'formik';
// // // // // import * as Yup from 'yup';
// // // // // import { adminService } from '../../services/admin';
// // // // // import { BUSINESS_STATUS } from '../../utils/constants';

// // // // // const validationSchema = Yup.object({
// // // // //   businessName:       Yup.string().required('Business Name is required').min(2, 'Business Name must be at least 2 characters').max(100),
// // // // //   industry:           Yup.string().required('Industry is required'),
// // // // //   contactEmail:       Yup.string().email('Invalid email').required('Contact Email is required'),
// // // // //   emergencyContactNo: Yup.string().matches(/^[0-9]+$/, 'Only digits allowed').min(7, 'Min 7 digits').max(15, 'Max 15 digits').required('Emergency Contact is required'),
// // // // //   websiteUrl:         Yup.string().url('Enter a valid URL').required('Website URL is required'),
// // // // //   webhookUrl:         Yup.string().required('Webhook URL is required'),
// // // // //   accountStatus:      Yup.string().required('Account Status is required'),
// // // // //   authType:           Yup.string().oneOf(['IN_APP', 'TOTP']).required('Auth Type is required'),
// // // // // });

// // // // // const emptyDomainRow = () => ({
// // // // //   domainName:         'http://',   // ← full URL stored here
// // // // //   originalDomainName: '',
// // // // //   businessName:       '',
// // // // //   businessLogo:       'https://', // ← full URL stored here
// // // // //   redirectUrl:        'https://', // ← full URL stored here
// // // // //   expanded:           true,
// // // // //   saved:              false,
// // // // //   error:              '',
// // // // //   logoError:          '',
// // // // //   redirectError:      '',
// // // // // });

// // // // // // Add near isValidDomain:
// // // // // const getProtocol = (url = '') => {
// // // // //   const match = url.match(/^(https?):/);
// // // // //   return match ? match[1] : 'https';
// // // // // };

// // // // // const replaceProtocol = (url = '', newProtocol) => {
// // // // //   return url.replace(/^https?:\/\//, `${newProtocol}://`);
// // // // // };

// // // // // const isValidDomain = (domain) => {
// // // // //   const withTLD  = /^(https?:\/\/)?(?!-)[a-zA-Z0-9-_]{1,63}(\.(?!-)[a-zA-Z0-9-_]{1,63})*\.[a-zA-Z]{2,63}(:\d{1,5})?$/;
// // // // //   const withPort = /^(https?:\/\/)?[a-zA-Z0-9-_]+(:\d{1,5})$/;
// // // // //   return withTLD.test(domain) || withPort.test(domain);
// // // // // };

// // // // // const isValidUrl = (url) => {
// // // // //   try { new URL(url); return true; }
// // // // //   catch { return false; }
// // // // // };




// // // // // const CreateBusiness = ({ business, isEditMode = false, onSuccess }) => {
// // // // //   const navigate = useNavigate();
// // // // //   const [loading, setLoading]   = useState(false);
// // // // //   const [error, setError]       = useState('');
// // // // //   const [success, setSuccess]   = useState('');

// // // // //   // Domain / whitelabel state
// // // // //   const [domainRows, setDomainRows]       = useState([emptyDomainRow()]);
// // // // //   const [domainLoading, setDomainLoading] = useState(false);
// // // // //   const [domainError, setDomainError]     = useState('');
// // // // //   const [createdBusinessId, setCreatedBusinessId] = useState(null);
// // // // //   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });
// // // // //   // Add state:
// // // // // const [confirmRemoveIndex, setConfirmRemoveIndex] = useState(null);
// // // // // const showSnackbar = (message, severity = 'error') => {
// // // // //   setSnackbar({ open: true, message, severity });
// // // // //   setTimeout(() => setSnackbar(s => ({ ...s, open: false })), 3000);
// // // // // };
// // // // // const isDoneBlocked = domainRows.some(r =>
// // // // //   r.error || r.logoError || r.redirectError ||           // any row has an error
// // // // //   (r.domainName.trim() && !r.saved)                     // typed but not saved
// // // // // );
// // // // // // In edit mode, this is just business._id
// // // // // const activeBusinessId = isEditMode ? business?._id : createdBusinessId;
// // // // //   const setRowError = (index, message) =>
// // // // //   setDomainRows(rows =>
// // // // //     rows.map((r, i) => i === index ? { ...r, error: message } : r)
// // // // //   );

// // // // //   const formik = useFormik({
// // // // //     initialValues: {
// // // // //       businessName: '',
// // // // //       industry: '',
// // // // //       contactEmail: '',
// // // // //       emergencyContactNo: '',
// // // // //       websiteUrl: '',
// // // // //       webhookUrl: '',
// // // // //       accountStatus: BUSINESS_STATUS.ACTIVE,
// // // // //       authType: 'IN_APP',
// // // // //     },
// // // // //     validationSchema,
// // // // //     // onSubmit: async (values) => {
// // // // //     //   try {
// // // // //     //     setLoading(true);
// // // // //     //     setError('');
// // // // //     //     setSuccess('');

// // // // //     //     if (isEditMode) {
// // // // //     //       await adminService.updateBusiness(business._id, values);
// // // // //     //     } else {
// // // // //     //       await adminService.createBusiness(values);
// // // // //     //     }

// // // // //     //     setSuccess(isEditMode ? 'Business updated!' : 'Business created!');
// // // // //     //     setTimeout(() => onSuccess?.(), 1200);
// // // // //     //   } catch (err) {
// // // // //     //     setError(err.message || 'Something went wrong');
// // // // //     //   } finally {
// // // // //     //     setLoading(false);
// // // // //     //   }
// // // // //     // },
// // // // //    onSubmit: async (values) => {
// // // // //   try {
// // // // //     setLoading(true);
// // // // //     setError('');
// // // // //     setSuccess('');

// // // // //     if (isEditMode) {
// // // // //       await adminService.updateBusiness(business._id, values);
// // // // //       showSnackbar('Business updated!', 'success');
// // // // //       setTimeout(() => onSuccess?.(), 1200);
// // // // //     } else {
// // // // //       const response = await adminService.createBusiness(values);
// // // // //       const newId = response?.data?._id;
// // // // //       if (!newId) throw new Error('Business created but no ID returned');

// // // // //       setCreatedBusinessId(newId);   // ← unlock domain section
// // // // //       showSnackbar('Business created! You can now configure domains below.', 'success');
// // // // //       // don't navigate away, don't call onSuccess yet
// // // // //     }
// // // // //   } catch (err) {
// // // // //     showSnackbar(err.message || 'Something went wrong');
// // // // //   } finally {
// // // // //     setLoading(false);
// // // // //   }
// // // // // },
// // // // //   });

// // // // //   useEffect(() => {
// // // // //   if (!isEditMode || !business) return;

// // // // //   formik.setValues({
// // // // //     businessName:        business.businessName        || '',
// // // // //     industry:            business.industry            || '',
// // // // //     contactEmail:        business.contactEmail        || '',
// // // // //     emergencyContactNo:  business.emergencyContactNo  || '',
// // // // //     websiteUrl:          business.websiteUrl          || '',
// // // // //     webhookUrl:          business.webhookUrl          || '',
// // // // //     accountStatus:       business.accountStatus       || BUSINESS_STATUS.ACTIVE,
// // // // //     authType:            business.authType            || 'IN_APP',
// // // // //   });

// // // // //   (async () => {
// // // // //     try {
// // // // //       // Fetch both in parallel
// // // // //       const [allowlistRes, whitelabelRes] = await Promise.allSettled([
// // // // //         adminService.getAllowlist(business._id),
// // // // //         adminService.getWhiteLabels(business._id),
// // // // //       ]);

// // // // //       const allowedDomains =
// // // // //         allowlistRes.status === 'fulfilled'
// // // // //           ? allowlistRes.value.allowedDomains || []
// // // // //           : [];

// // // // //       const wlMap =
// // // // //         whitelabelRes.status === 'fulfilled'
// // // // //           ? Object.fromEntries(
// // // // //               (whitelabelRes.value.whiteLabels || []).map(wl => [wl.domainName, wl])
// // // // //             )
// // // // //           : {};

// // // // //       if (whitelabelRes.status === 'rejected') {
// // // // //         console.warn('Whitelabel fetch failed:', whitelabelRes.reason);
// // // // //       }

// // // // //       if (allowedDomains.length) {
// // // // //         setDomainRows(
// // // // //           allowedDomains.map(domain => {
// // // // //             const url = domain.match(/^(https?):\/\/(.+)/);
// // // // //             return{
// // // // //             domainProtocol:     url ? url[1] : 'http',
// // // // //             domainName:         url ? url[2] : domain,
// // // // //             originalDomainName:  domain,
// // // // //             // ↓ these will now be populated from wlMap
// // // // //             businessName: wlMap[domain]?.businessName || '',
// // // // //             businessLogo: wlMap[domain]?.businessLogo || '',
// // // // //             redirectUrl:  wlMap[domain]?.redirectUrl  || '',
// // // // //             expanded:     false,
// // // // //             saved:        true,
// // // // //             };
// // // // //       }))
// // // // //       }
// // // // //     } catch (err) {
// // // // //       console.error('Failed to load domain config:', err);
// // // // //     }
// // // // //   })();
// // // // // }, [isEditMode, business?._id]);
// // // // //   // ── Domain row helpers ──────────────────────────────────────────────────────

// // // // //    const normalizeDomain = (raw = '') =>
// // // // //     raw.trim().toLowerCase().replace(/\/+$/, '');
   
// // // // //   const updateRow = (index, field, value) =>
// // // // //     setDomainRows(rows =>
// // // // //       rows.map((r, i) => i === index ? { ...r, [field]: value, saved: false } : r)
// // // // //     );

// // // // //   const toggleExpanded = (index) =>
// // // // //     setDomainRows(rows =>
// // // // //       rows.map((r, i) => i === index ? { ...r, expanded: !r.expanded } : r)
// // // // //     );

// // // // //   const addRow = () =>
// // // // //     setDomainRows(rows => [...rows, emptyDomainRow()]);

// // // // // const saveDomainRow = async (index) => {
// // // // //   const row    = domainRows[index];
// // // // //   const domain = row.domainName.trim();

// // // // //   let hasError = false;

// // // // //  if (!row.domainName.trim() || row.domainName.trim() === 'http://' || row.domainName.trim() === 'https://') {
// // // // //   setRowError(index, 'Domain name is required');
// // // // //   return;
// // // // // }

// // // // //   if (row.businessLogo.trim()) {
// // // // //     const logoUrl = `${row.logoProtocol}://${row.businessLogo}`;
// // // // //     if (!isValidUrl(logoUrl)) {
// // // // //       setDomainRows(rows => rows.map((r, i) => i === index ? { ...r, logoError: 'Invalid logo URL' } : r));
// // // // //       hasError = true;
// // // // //     } else {
// // // // //       setDomainRows(rows => rows.map((r, i) => i === index ? { ...r, logoError: '' } : r));
// // // // //     }
// // // // //   }

// // // // //   if (row.redirectUrl.trim()) {
// // // // //     const redirUrl = `${row.redirectProtocol}://${row.redirectUrl}`;
// // // // //     if (!isValidUrl(redirUrl)) {
// // // // //       setDomainRows(rows => rows.map((r, i) => i === index ? { ...r, redirectError: 'Invalid redirect URL' } : r));
// // // // //       hasError = true;
// // // // //     } else {
// // // // //       setDomainRows(rows => rows.map((r, i) => i === index ? { ...r, redirectError: '' } : r));
// // // // //     }
// // // // //   }

// // // // //   if (hasError) return;
// // // // //   setDomainLoading(true);

// // // // //   try {
// // // // //     const origDomain = normalizeDomain(row.originalDomainName);
// // // // //     const isExisting = Boolean(origDomain);
   

// // // // //     if (!isEditMode) {
// // // // //       // business already created at this point, activeBusinessId exists
// // // // //     } 

// // // // //     if (isExisting && domain !== origDomain) {
// // // // //       const result = await adminService.editDomain(activeBusinessId, origDomain, domain);
// // // // //       if (result.alreadyExists || result.invalidDomain) { setRowError(index, result.message); return; }
// // // // //     } else if (!isExisting) {
// // // // //       const result = await adminService.addDomain(activeBusinessId, domain);
// // // // //       if (result.alreadyExists || result.invalidDomain) { setRowError(index, result.message); return; }
// // // // //     }

// // // // //     await adminService.upsertWhiteLabel(domain, {
// // // // //   businessName: row.businessName || null,
// // // // //   businessLogo: row.businessLogo.trim() || null,   // ← raw, no prepending
// // // // //   redirectUrl:  row.redirectUrl.trim()  || null,   // ← raw, no prepending
// // // // // });

// // // // //     setDomainRows(rows =>
// // // // //       rows.map((r, i) =>
// // // // //         i === index
// // // // //           ? { ...r, saved: true, expanded: false, originalDomainName: domain, domainName: domain }
// // // // //           : r
// // // // //       )
// // // // //     );
// // // // //   } catch (err) {
// // // // //     setRowError(index, err.message || 'Failed to save domain');
// // // // //   } finally {
// // // // //     setDomainLoading(false);
// // // // //   }
// // // // // };

// // // // //   const removeDomainRow = async (index) => {
// // // // //   const row = domainRows[index];

 

// // // // //   if (row.saved && activeBusinessId) {
// // // // //     setDomainLoading(true);
// // // // //     try {
// // // // //       await adminService.removeDomain(activeBusinessId, normalizeDomain(row.originalDomainName)); // ← use originalDomainName, normalized
// // // // //     } catch (err) {
// // // // //       setDomainError(err.message || 'Failed to remove domain');
// // // // //       setDomainLoading(false);
// // // // //       return;
// // // // //     }
// // // // //     setDomainLoading(false);
// // // // //   }

// // // // //   setDomainRows(rows => rows.filter((_, i) => i !== index));
// // // // // };

// // // // //   // ── Styles ──────────────────────────────────────────────────────────────────

// // // // //   const inputStyle = {
// // // // //     width: '100%',
// // // // //     marginTop: 6,
// // // // //     padding: '9px 12px',
// // // // //     fontSize: 14,
// // // // //     borderRadius: 6,
// // // // //     border: '1px solid #e2e8f0',
// // // // //     background: '#f8fafc',
// // // // //     boxSizing: 'border-box',
// // // // //   };

// // // // //   const industries = [
// // // // //     'Technology','Finance','Healthcare','Retail','Education',
// // // // //     'Manufacturing','Real Estate','Hospitality','Transportation','Other',
// // // // //   ];

// // // // //   return (
// // // // //     <div style={{
// // // // //       minHeight: '100%',
// // // // //       background: '#2563EB',
// // // // //       fontFamily: "'Inter','Segoe UI',sans-serif",
// // // // //       paddingTop: 24,
// // // // //     }}>
// // // // //       <div style={{ display: 'flex', flexDirection: 'column' }}>

     
// // // // //         {/* HEADER */}
// // // // //         <div style={{ marginBottom: 16 }}>
// // // // //           <h1 style={{
// // // // //             fontSize: 22, fontWeight: 700, margin: '3px 20px 3px 3px',
// // // // //             background: '#2563EB',
// // // // //             WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
// // // // //             paddingLeft:15,
// // // // //           }}>
// // // // //             {isEditMode ? 'Edit Business' : 'Create New Business'}
// // // // //           </h1>
// // // // //           <p style={{ fontSize: 13, marginTop: 4, marginLeft: 2, color: '#4a5568',paddingLeft:15 }}>
// // // // //             {isEditMode ? 'Update business information' : 'Add a new business'}
// // // // //           </p>
// // // // //         </div>

// // // // //         {/* CARD */}
// // // // //         <div style={{
// // // // //           width: '100%',
// // // // //           background: '#2563EB',
// // // // //           borderRadius: 14,
// // // // //           border: '1px solid rgba(49,130,206,0.15)',
// // // // //           boxShadow: '0 10px 25px rgba(49,130,206,0.08),0 4px 10px rgba(0,0,0,0.04)',
// // // // //           display: 'flex', flexDirection: 'column',
// // // // //         }}>

// // // // //           {(error || success) && (
// // // // //             <div style={{ padding: '12px 24px' }}>
// // // // //               {error   && <div style={{ color: '#c53030', fontSize: 13 }}>{error}</div>}
// // // // //               {success && <div style={{ color: '#276749', fontSize: 13 }}>{success}</div>}
// // // // //             </div>
// // // // //           )}

// // // // //           <div style={{ padding: '16px 24px' }}>
// // // // //             <form onSubmit={formik.handleSubmit}>

// // // // //               {/* ── Business fields grid ── */}
// // // // //               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '18px 24px' }}>
// // // // //                 {[
// // // // //                   ['Business Name',     'businessName',      'text'],
// // // // //                   ['Contact Email',     'contactEmail',      'email'],
// // // // //                   ['Emergency Contact', 'emergencyContactNo','text'],
// // // // //                   ['Website URL',       'websiteUrl',        'url'],
// // // // //                   ['Webhook URL',       'webhookUrl',        'url'],    
// // // // //                 ].map(([label, name, type]) => (
// // // // //                   <div key={name}>
// // // // //                     <label style={{ fontSize: 13, fontWeight: 600 }}>{label}</label>
// // // // //                     <input
// // // // //                       type={type} name={name}
// // // // //                       value={formik.values[name]}
// // // // //                       onChange={formik.handleChange}
// // // // //                       onBlur={formik.handleBlur}
// // // // //                       style={inputStyle}
// // // // //                     />
// // // // //                     {formik.touched[name] && formik.errors[name] && (
// // // // //                       <div style={{ fontSize: 12, color: '#e53e3e', marginTop: 4 }}>
// // // // //                         {formik.errors[name]}
// // // // //                       </div>
// // // // //                     )}
// // // // //                   </div>
// // // // //                 ))}

// // // // //                 <div>
// // // // //                   <label style={{ fontSize: 13, fontWeight: 600 }}>Industry</label>
// // // // //                   <select name="industry" value={formik.values.industry}
// // // // //                     onChange={formik.handleChange} style={inputStyle}>
// // // // //                     <option value="">Select</option>
// // // // //                     {industries.map(i => <option key={i}>{i}</option>)}
// // // // //                   </select>
// // // // //                 </div>

// // // // //                 <div>
// // // // //                   <label style={{ fontSize: 13, fontWeight: 600 }}>Account Status</label>
// // // // //                   <select name="accountStatus" value={formik.values.accountStatus}
// // // // //                     onChange={formik.handleChange} style={inputStyle}>
// // // // //                     {Object.values(BUSINESS_STATUS).map(s => <option key={s}>{s}</option>)}
// // // // //                   </select>
// // // // //                 </div>
// // // // //               </div>

// // // // //               {/* ── Domain / Whitelabel section ── */}
// // // // //              <div style={{ marginTop: 28, opacity: (!isEditMode && !createdBusinessId) ? 0.4 : 1,
// // // // //               pointerEvents: (!isEditMode && !createdBusinessId) ? 'none' : 'auto' }}>
// // // // //   <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
// // // // //     <div>
// // // // //       <span style={{ fontSize: 14, fontWeight: 700, color: '#2d3748' }}>
// // // // //         Domain Configuration
// // // // //       </span>
// // // // //       <span style={{ fontSize: 12, color: '#718096', marginLeft: 8 }}>
// // // // //         {(!isEditMode && !createdBusinessId)
// // // // //           ? '⚠ Create the business first to configure domains'
// // // // //           : 'Allowed domains & per-domain branding'}
// // // // //       </span>
// // // // //     </div>
// // // // //     <button type="button" onClick={addRow} style={{
// // // // //     padding: '6px 14px', fontSize: 13, fontWeight: 600,
// // // // //     background: '#ebf4ff', border: '1px solid #bee3f8',
// // // // //     borderRadius: 6, color: '#2b6cb0', cursor: 'pointer',
// // // // //   }}>
// // // // //     + Add Domain
// // // // //   </button>
// // // // //     </div>

// // // // //                 {domainError && (
// // // // //                   <div style={{ fontSize: 12, color: '#c53030', marginBottom: 8 }}>{domainError}</div>
// // // // //                 )}

// // // // //                 <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
// // // // //                   {domainRows.map((row, i) => (
// // // // //                     <div key={i} style={{
// // // // //                       border: '1px solid #e2e8f0', borderRadius: 8,
// // // // //                       background: row.saved ? '#f7fafc' : '#fff',
// // // // //                       overflow: 'hidden',
// // // // //                     }}>

// // // // //                       {/* Row header */}
// // // // //                       <div style={{
// // // // //                         display: 'flex', alignItems: 'center',
// // // // //                         justifyContent: 'space-between',
// // // // //                         padding: '10px 14px',
// // // // //                         background: row.saved ? '#edf2f7' : '#fff',
// // // // //                         cursor: 'pointer',
// // // // //                       }} onClick={() => toggleExpanded(i)}>
// // // // //                         <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
// // // // //                           <span style={{ fontSize: 13, color: '#718096' }}>🌐</span>
// // // // //                           <span style={{ fontSize: 13, fontWeight: 600, color: '#2d3748' }}>
// // // // //                             {row.domainName || `Domain ${i + 1}`}
// // // // //                           </span>
// // // // //                           {row.saved && (
// // // // //                             <span style={{
// // // // //                               fontSize: 11, padding: '2px 7px', borderRadius: 10,
// // // // //                               background: '#c6f6d5', color: '#276749', fontWeight: 600,
// // // // //                             }}>saved</span>
// // // // //                           )}
// // // // //                         </div>
// // // // //                         <div style={{ display: 'flex', gap: 8 }}>
// // // // //                           <span style={{ fontSize: 12, color: '#718096' }}>
// // // // //                             {row.expanded ? '▲' : '▼'}
// // // // //                           </span>
// // // // //                         </div>
// // // // //                       </div>

// // // // //                       {/* Expanded fields */}
// // // // //                       {row.expanded && (
// // // // //                         <div style={{ padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 10 }}>
// // // // //                           <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 16px' }}>

// // // // //                          {/* Domain Name */}
// // // // // <div>
// // // // //   <label style={{ fontSize: 12, fontWeight: 600, color: '#4a5568' }}>
// // // // //     Domain Name <span style={{ color: '#e53e3e' }}>*</span>
// // // // //   </label>
// // // // //   <div style={{ display: 'flex', marginTop: 6 }}>
// // // // //     <select
// // // // //       value={getProtocol(row.domainName)}
// // // // //       onChange={e => {
// // // // //         updateRow(i, 'domainName', replaceProtocol(row.domainName, e.target.value));
// // // // //         setRowError(i, '');
// // // // //       }}
// // // // //       style={{
// // // // //         padding: '9px 8px', fontSize: 13,
// // // // //         borderRadius: '6px 0 0 6px',
// // // // //         border: '1px solid #e2e8f0', borderRight: 'none',
// // // // //         background: '#edf2f7', color: '#4a5568', cursor: 'pointer',
// // // // //       }}>
// // // // //       <option value="http">http</option>
// // // // //       <option value="https">https</option>
// // // // //     </select>
// // // // //     <input
// // // // //       type="text"
// // // // //       placeholder="app.example.com"
// // // // //       value={row.domainName.replace(/^https?:\/\//, '')}  // ← show only host in input
// // // // //       onChange={e => {
// // // // //         const host = e.target.value.replace(/^https?:\/\//, ''); // strip if user pastes full URL
// // // // //         updateRow(i, 'domainName', `${getProtocol(row.domainName)}://${host}`);
// // // // //         setRowError(i, '');
// // // // //       }}
// // // // //       style={{
// // // // //         flex: 1, padding: '9px 12px', fontSize: 14,
// // // // //         borderRadius: '0 6px 6px 0',
// // // // //         border: row.error ? '1px solid #fc8181' : '1px solid #e2e8f0',
// // // // //         borderLeft: 'none',
// // // // //         background: row.saved ? '#edf2f7' : '#f8fafc',
// // // // //       }}
// // // // //     />
// // // // //   </div>
// // // // //   {row.error && <div style={{ fontSize: 12, color: '#c53030', marginTop: 4 }}>⚠ {row.error}</div>}
// // // // // </div>


// // // // //                             <div>
// // // // //                               <label style={{ fontSize: 12, fontWeight: 600, color: '#4a5568' }}>
// // // // //                                 Business Name Override
// // // // //                               </label>
// // // // //                               <input
// // // // //                                 type="text"
// // // // //                                 placeholder="Display name on ACS screen"
// // // // //                                 value={row.businessName}
// // // // //                                 onChange={e => updateRow(i, 'businessName', e.target.value)}
// // // // //                                 style={inputStyle}
// // // // //                               />
// // // // //                             </div>

// // // // //                            {/* Logo URL */}

// // // // // {/* Logo URL */}
// // // // // <div>
// // // // //   <label style={{ fontSize: 12, fontWeight: 600, color: '#4a5568' }}>Logo URL</label>
// // // // //   <div style={{ display: 'flex', marginTop: 6 }}>
// // // // //     <select
// // // // //       value={getProtocol(row.businessLogo)}
// // // // //       onChange={e => {
// // // // //         updateRow(i, 'businessLogo', replaceProtocol(row.businessLogo, e.target.value));
// // // // //         setDomainRows(rows => rows.map((r, idx) => idx === i ? { ...r, logoError: '' } : r));
// // // // //       }}
// // // // //       style={{
// // // // //         padding: '9px 8px', fontSize: 13,
// // // // //         borderRadius: '6px 0 0 6px',
// // // // //         border: '1px solid #e2e8f0', borderRight: 'none',
// // // // //         background: '#edf2f7', color: '#4a5568', cursor: 'pointer',
// // // // //       }}>
// // // // //       <option value="http">http</option>
// // // // //       <option value="https">https</option>
// // // // //     </select>
// // // // //     <input
// // // // //       type="text"
// // // // //       placeholder="cdn.example.com/logo.png"
// // // // //       value={row.businessLogo.replace(/^https?:\/\//, '')}
// // // // //       onChange={e => {
// // // // //         const rest = e.target.value.replace(/^https?:\/\//, '');
// // // // //         updateRow(i, 'businessLogo', `${getProtocol(row.businessLogo)}://${rest}`);
// // // // //         setDomainRows(rows => rows.map((r, idx) => idx === i ? { ...r, logoError: '' } : r));
// // // // //       }}
// // // // //       style={{
// // // // //         flex: 1, padding: '9px 12px', fontSize: 14,
// // // // //         borderRadius: '0 6px 6px 0',
// // // // //         border: row.logoError ? '1px solid #fc8181' : '1px solid #e2e8f0',
// // // // //         borderLeft: 'none', background: '#f8fafc',
// // // // //       }}
// // // // //     />
// // // // //   </div>
// // // // //   {row.logoError && <div style={{ fontSize: 12, color: '#c53030', marginTop: 4 }}>⚠ {row.logoError}</div>}
// // // // // </div>

// // // // // {/* Redirect URL */}
// // // // // <div>
// // // // //   <label style={{ fontSize: 12, fontWeight: 600, color: '#4a5568' }}>Redirect URL</label>
// // // // //   <div style={{ display: 'flex', marginTop: 6 }}>
// // // // //     <select
// // // // //       value={getProtocol(row.redirectUrl)}
// // // // //       onChange={e => {
// // // // //         updateRow(i, 'redirectUrl', replaceProtocol(row.redirectUrl, e.target.value));
// // // // //         setDomainRows(rows => rows.map((r, idx) => idx === i ? { ...r, redirectError: '' } : r));
// // // // //       }}
// // // // //       style={{
// // // // //         padding: '9px 8px', fontSize: 13,
// // // // //         borderRadius: '6px 0 0 6px',
// // // // //         border: '1px solid #e2e8f0', borderRight: 'none',
// // // // //         background: '#edf2f7', color: '#4a5568', cursor: 'pointer',
// // // // //       }}>
// // // // //       <option value="http">http</option>
// // // // //       <option value="https">https</option>
// // // // //     </select>
// // // // //     <input
// // // // //       type="text"
// // // // //       placeholder="app.example.com/callback"
// // // // //       value={row.redirectUrl.replace(/^https?:\/\//, '')}
// // // // //       onChange={e => {
// // // // //         const rest = e.target.value.replace(/^https?:\/\//, '');
// // // // //         updateRow(i, 'redirectUrl', `${getProtocol(row.redirectUrl)}://${rest}`);
// // // // //         setDomainRows(rows => rows.map((r, idx) => idx === i ? { ...r, redirectError: '' } : r));
// // // // //       }}
// // // // //       style={{
// // // // //         flex: 1, padding: '9px 12px', fontSize: 14,
// // // // //         borderRadius: '0 6px 6px 0',
// // // // //         border: row.redirectError ? '1px solid #fc8181' : '1px solid #e2e8f0',
// // // // //         borderLeft: 'none', background: '#f8fafc',
// // // // //       }}
// // // // //     />
// // // // //   </div>
// // // // //   {row.redirectError && <div style={{ fontSize: 12, color: '#c53030', marginTop: 4 }}>⚠ {row.redirectError}</div>}
// // // // // </div>
// // // // //                           </div>

// // // // //                           <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 4 }}>
// // // // //                             <button type="button" onClick={() => setConfirmRemoveIndex(i)}
// // // // //                               disabled={domainLoading}
// // // // //                               style={{
// // // // //                                 padding: '7px 16px', fontSize: 12, fontWeight: 600,
// // // // //                                 background: '#fff5f5', border: '1px solid #fed7d7',
// // // // //                                 borderRadius: 6, color: '#c53030', cursor: 'pointer',
// // // // //                               }}>
// // // // //                               Remove
// // // // //                             </button>
// // // // //                             <button type="button" onClick={() => saveDomainRow(i)}
// // // // //                               disabled={domainLoading || !row.domainName.trim()}
// // // // //                               style={{
// // // // //                                 padding: '7px 16px', fontSize: 12, fontWeight: 600,
// // // // //                                 background: '#2563EB',
// // // // //                                 border: 'none', borderRadius: 6,
// // // // //                                 color: '#fff', cursor: domainLoading ? 'not-allowed' : 'pointer',
// // // // //                               }}>
// // // // //                               {domainLoading ? 'Saving…' : 'Save Domain'}
// // // // //                             </button>
// // // // //                           </div>
// // // // //                         </div>
// // // // //                       )}
// // // // //                     </div>
// // // // //                   ))}
// // // // //                 </div>
// // // // //               </div>

// // // // //             </form>
// // // // //           </div>

// // // // //           {/* FOOTER */}
// // // // //           <div style={{
// // // // //             padding: '22px 30px',
// // // // //             borderTop: '1px solid #e2e8f0',
// // // // //             background: '#2563EB',
// // // // //             display: 'flex', justifyContent: 'space-between', alignItems: 'center',
// // // // //           }}>
// // // // //             <div style={{ fontSize: 14, color: '#718096' }}>
// // // // //               {isEditMode ? 'Update business details' : 'Create a new business account'}
// // // // //             </div>
// // // // //             <div style={{ display: 'flex', gap: 16 }}>
// // // // //               <button type="button" onClick={() => navigate('/admin/businesses')}
// // // // //                 disabled={loading} style={{
// // // // //                   padding: '12px 28px', background: '#fff',
// // // // //                   border: '1px solid #cbd5e0', borderRadius: 8,
// // // // //                   fontSize: 15, fontWeight: 600, cursor: 'pointer',
// // // // //                 }}>
// // // // //                 Cancel
// // // // //               </button>
            
// // // // // {!isEditMode && createdBusinessId ? (
// // // // //   <button
// // // // //   type="button"
// // // // //   onClick={() => onSuccess?.()}
// // // // //   disabled={isDoneBlocked}
// // // // //   style={{
// // // // //     padding: '12px 32px',
// // // // //     background: isDoneBlocked
// // // // //       ? '#a0aec0'
// // // // //       : '#2563EB',
// // // // //     border: 'none', borderRadius: 8, color: '#fff',
// // // // //     fontSize: 15, fontWeight: 600,
// // // // //     cursor: isDoneBlocked ? 'not-allowed' : 'pointer',
// // // // //     boxShadow: isDoneBlocked ? 'none' : '0 6px 14px rgba(56,161,105,0.3)',
// // // // //   }}>
// // // // //   Done
// // // // // </button>
// // // // // ) : (
// // // // //   <button type="button" onClick={formik.handleSubmit}
// // // // //     disabled={loading || !formik.isValid || Boolean(createdBusinessId)}
// // // // //     style={{
// // // // //       padding: '12px 32px',
// // // // //       background: '#2563EB',
// // // // //       border: 'none', borderRadius: 8, color: '#fff',
// // // // //       fontSize: 15, fontWeight: 600,
// // // // //       cursor: (loading || Boolean(createdBusinessId)) ? 'not-allowed' : 'pointer',
// // // // //       boxShadow: '0 6px 14px rgba(49,130,206,0.3)',
// // // // //     }}>
// // // // //     {loading ? 'Processing…' : isEditMode ? 'Update Business' : 'Create Business'}
// // // // //   </button>
// // // // // )}
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>
// // // // //       </div>
// // // // //     {snackbar.open && (
// // // // //   <div
// // // // //     onClick={() => setSnackbar(s => ({ ...s, open: false }))}
// // // // //     style={{
// // // // //       position: 'fixed',
// // // // //       top: 72,                          // ← below navbar
// // // // //       left: '50%',
// // // // //       transform: 'translateX(-50%)',
// // // // //       background: snackbar.severity === 'success' ? '#276749' : '#c53030',  // ← green for success
// // // // //       color: '#fff',
// // // // //       padding: '12px 24px',
// // // // //       borderRadius: 8,
// // // // //       fontSize: 14,
// // // // //       fontWeight: 500,
// // // // //       boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
// // // // //       zIndex: 99999,
// // // // //       cursor: 'pointer',
// // // // //       maxWidth: 480,
// // // // //       textAlign: 'center',
// // // // //     }}>
// // // // //     {snackbar.message}
// // // // //     <span style={{ marginLeft: 16, opacity: 0.7, fontSize: 12 }}>✕</span>
// // // // //   </div>

// // // // // )}

// // // // // {confirmRemoveIndex !== null && (
// // // // //   <div style={{
// // // // //     position: 'fixed', inset: 0, zIndex: 99999,
// // // // //     background: 'rgba(0,0,0,0.4)',
// // // // //     display: 'flex', alignItems: 'center', justifyContent: 'center',
// // // // //   }}>
// // // // //     <div style={{
// // // // //       background: '#fff', borderRadius: 12, padding: '28px 32px',
// // // // //       boxShadow: '0 8px 32px rgba(0,0,0,0.18)', maxWidth: 400, width: '90%',
// // // // //     }}>
// // // // //       <h3 style={{ margin: '0 0 8px', fontSize: 16, fontWeight: 700, color: '#1a202c' }}>
// // // // //         Remove Domain
// // // // //       </h3>
// // // // //       <p style={{ fontSize: 14, color: '#4a5568', margin: '0 0 24px' }}>
// // // // //         Are you sure you want to remove{' '}
// // // // //         <strong style={{ color: '#c53030', fontFamily: 'monospace' }}>
// // // // //           {domainRows[confirmRemoveIndex]?.domainName}
// // // // //         </strong>
// // // // //         ? This cannot be undone.
// // // // //       </p>
// // // // //       <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
// // // // //         <button
// // // // //           type="button"
// // // // //           onClick={() => setConfirmRemoveIndex(null)}
// // // // //           style={{
// // // // //             padding: '8px 20px', fontSize: 13, fontWeight: 600,
// // // // //             background: '#fff', border: '1px solid #cbd5e0',
// // // // //             borderRadius: 6, cursor: 'pointer', color: '#4a5568',
// // // // //           }}>
// // // // //           Cancel
// // // // //         </button>
// // // // //         <button
// // // // //           type="button"
// // // // //           onClick={async () => {
// // // // //             const idx = confirmRemoveIndex;
// // // // //             setConfirmRemoveIndex(null);
// // // // //             await removeDomainRow(idx);
// // // // //           }}
// // // // //           style={{
// // // // //             padding: '8px 20px', fontSize: 13, fontWeight: 600,
// // // // //             background: '#2563EB',
// // // // //             border: 'none', borderRadius: 6,
// // // // //             color: '#fff', cursor: 'pointer',
// // // // //           }}>
// // // // //           Remove
// // // // //         </button>
// // // // //       </div>
// // // // //     </div>
// // // // //   </div>
// // // // // )}
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default CreateBusiness;


// // // // import React, { useEffect } from 'react';
// // // // import { useNavigate } from 'react-router-dom';
// // // // import { useFormik } from 'formik';
// // // // import * as Yup from 'yup';
// // // // import {
// // // //   Container,
// // // //   Box,
// // // //   Typography,
// // // //   Button,
// // // //   TextField,
// // // //   Select,
// // // //   MenuItem,
// // // //   FormControl,
// // // //   Switch,
// // // //   IconButton,
// // // //   Alert,
// // // //   CircularProgress,
// // // //   Paper,
// // // //   Grid,
// // // //   Divider,
// // // //   Breadcrumbs,
// // // //   Link as MuiLink,
// // // //   Chip,
// // // //   FormHelperText,
// // // //   Snackbar,
// // // // } from '@mui/material';
// // // // import {
// // // //   ArrowBack as ArrowBackIcon,
// // // //   CheckCircle,
// // // //   Business as BusinessIcon,
// // // //   InfoOutlined,
// // // //   Close as CloseIcon,
// // // // } from '@mui/icons-material';
// // // // import { adminService } from '../../services/admin';
// // // // import { BUSINESS_STATUS } from '../../utils/constants';

// // // // /* ----------------------------------------------------------------------
// // // //    Design tokens — kept consistent with CreateApplicationPage
// // // // ---------------------------------------------------------------------- */
// // // // const C = {
// // // //   border: '#e2e8f0',
// // // //   blue: '#3182ce',
// // // //   blueDark: '#2b6cb0',
// // // //   green: '#38a169',
// // // //   greenDark: '#276749',
// // // //   indigo: '#4c51bf',
// // // //   textPrimary: '#1a202c',
// // // //   textSecondary: '#718096',
// // // //   bgLight: '#f7fafc',
// // // //   badgeActiveBg: '#c6f6d5',
// // // //   badgeActiveText: '#276749',
// // // //   badgeInactiveBg: '#e2e8f0',
// // // //   badgeInactiveText: '#4a5568',
// // // //   infoBg: '#ebf8ff',
// // // //   infoBorder: '#bee3f8',
// // // //   infoText: '#2c5282',
// // // // };

// // // // const INDUSTRIES = [
// // // //   'Technology', 'Finance', 'Healthcare', 'Retail', 'Education',
// // // //   'Manufacturing', 'Real Estate', 'Hospitality', 'Transportation', 'Other',
// // // // ];

// // // // /* ----------------------------------------------------------------------
// // // //    Validation schema
// // // // ---------------------------------------------------------------------- */
// // // // const validationSchema = Yup.object({
// // // //   businessName: Yup.string()
// // // //     .required('Business Name is required')
// // // //     .min(2, 'Business Name must be at least 2 characters')
// // // //     .max(100),
// // // //   industry: Yup.string().required('Industry is required'),
// // // //   contactEmail: Yup.string().email('Invalid email').required('Contact Email is required'),
// // // //   emergencyContactNo: Yup.string()
// // // //     .matches(/^[0-9]+$/, 'Only digits allowed')
// // // //     .min(7, 'Min 7 digits')
// // // //     .max(15, 'Max 15 digits')
// // // //     .required('Emergency Contact is required'),
// // // //   websiteUrl: Yup.string().url('Enter a valid URL').required('Website URL is required'),
// // // //   webhookUrl: Yup.string().required('Webhook URL is required'),
// // // //   accountStatus: Yup.string().required('Account Status is required'),
// // // // });

// // // // /* ----------------------------------------------------------------------
// // // //    Inline field helper — label on the left, control on the right
// // // //    (matches the pattern used in CreateApplicationPage)
// // // // ---------------------------------------------------------------------- */
// // // // const InlineField = ({ label, children, ...boxProps }) => (
// // // //   <Box
// // // //     sx={{
// // // //       display: 'flex',
// // // //       alignItems: 'flex-start',
// // // //       gap: 2,
// // // //       mb: 2.5,
// // // //       ...boxProps.sx,
// // // //     }}
// // // //     {...boxProps}
// // // //   >
// // // //     <Typography
// // // //       variant="body1"
// // // //       fontWeight={600}
// // // //       sx={{
// // // //         minWidth: 180,
// // // //         flexShrink: 0,
// // // //         pt: 1,
// // // //         fontSize: 15,
// // // //         color: C.textPrimary,
// // // //         letterSpacing: 0.1,
// // // //       }}
// // // //     >
// // // //       {label}
// // // //     </Typography>
// // // //     <Box
// // // //       sx={{
// // // //         flex: 1,
// // // //         '& .MuiInputBase-input': { fontSize: 14.5 },
// // // //         '& .MuiInputBase-root': { fontSize: 14.5 },
// // // //         '& .MuiFormHelperText-root': { fontSize: 12.5, mx: 0, mt: 0.5 },
// // // //         '& .MuiSelect-select': { fontSize: 14.5 },
// // // //       }}
// // // //     >
// // // //       {children}
// // // //     </Box>
// // // //   </Box>
// // // // );

// // // // const StatusBadge = ({ active, label }) => (
// // // //   <Chip
// // // //     label={label}
// // // //     size="small"
// // // //     sx={{
// // // //       fontWeight: 700,
// // // //       fontSize: 11,
// // // //       height: 22,
// // // //       bgcolor: active ? C.badgeActiveBg : C.badgeInactiveBg,
// // // //       color: active ? C.badgeActiveText : C.badgeInactiveText,
// // // //     }}
// // // //   />
// // // // );

// // // // /* ----------------------------------------------------------------------
// // // //    Main Component
// // // // ---------------------------------------------------------------------- */
// // // // const CreateBusiness = ({ business, isEditMode = false, onSuccess }) => {
// // // //   const navigate = useNavigate();
// // // //   const [loading, setLoading] = React.useState(false);
// // // //   const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'error' });

// // // //   const showSnackbar = (message, severity = 'error') =>
// // // //     setSnackbar({ open: true, message, severity });

// // // //   const formik = useFormik({
// // // //     initialValues: {
// // // //       businessName: '',
// // // //       industry: '',
// // // //       contactEmail: '',
// // // //       emergencyContactNo: '',
// // // //       websiteUrl: '',
// // // //       webhookUrl: '',
// // // //       accountStatus: BUSINESS_STATUS.ACTIVE,
// // // //     },
// // // //     validationSchema,
// // // //     onSubmit: async (values) => {
// // // //       try {
// // // //         setLoading(true);
// // // //         if (isEditMode) {
// // // //           await adminService.updateBusiness(business._id, values);
// // // //           showSnackbar('Business updated!', 'success');
// // // //         } else {
// // // //           await adminService.createBusiness(values);
// // // //           showSnackbar('Business created!', 'success');
// // // //         }
// // // //         setTimeout(() => onSuccess?.(), 1000);
// // // //       } catch (err) {
// // // //         showSnackbar(err.message || 'Something went wrong');
// // // //       } finally {
// // // //         setLoading(false);
// // // //       }
// // // //     },
// // // //   });

// // // //   const { values, handleChange, handleBlur, setFieldValue, errors, touched } = formik;

// // // //   useEffect(() => {
// // // //     if (!isEditMode || !business) return;
// // // //     formik.setValues({
// // // //       businessName: business.businessName || '',
// // // //       industry: business.industry || '',
// // // //       contactEmail: business.contactEmail || '',
// // // //       emergencyContactNo: business.emergencyContactNo || '',
// // // //       websiteUrl: business.websiteUrl || '',
// // // //       webhookUrl: business.webhookUrl || '',
// // // //       accountStatus: business.accountStatus || BUSINESS_STATUS.ACTIVE,
// // // //     });
// // // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // // //   }, [isEditMode, business?._id]);

// // // //   const isActive = values.accountStatus === BUSINESS_STATUS.ACTIVE;

// // // //   return (
// // // //     <Container maxWidth="xl" sx={{ py: 3 }}>
// // // //       {/* HEADER */}
// // // //       <Box sx={{ mb: 3 }}>
// // // //         <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
// // // //           <MuiLink
// // // //             underline="hover"
// // // //             color="text.secondary"
// // // //             href="#"
// // // //             onClick={(e) => {
// // // //               e.preventDefault();
// // // //               navigate('/admin/businesses');
// // // //             }}
// // // //           >
// // // //             Businesses
// // // //           </MuiLink>
// // // //           <Typography color="text.primary" fontSize={13} fontWeight={600}>
// // // //             {isEditMode ? 'Edit Business' : 'Create Business'}
// // // //           </Typography>
// // // //         </Breadcrumbs>

// // // //         <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
// // // //           <Typography variant="h5" fontWeight={800} sx={{ color: C.textPrimary }}>
// // // //             {isEditMode ? 'Edit Business' : 'Create New Business'}
// // // //           </Typography>
// // // //           <Typography variant="body2" color="text.secondary">
// // // //             {isEditMode ? 'Update business information' : 'Add a new business account'}
// // // //           </Typography>
// // // //         </Box>
// // // //       </Box>

// // // //       {/* MAIN LAYOUT */}
// // // //       <Box
// // // //         sx={{
// // // //           display: 'flex',
// // // //           flexDirection: { xs: 'column', md: 'row' },
// // // //           alignItems: 'flex-start',
// // // //           gap: 3,
// // // //         }}
// // // //       >
// // // //         {/* LEFT — form */}
// // // //         <Box sx={{ flex: '1 1 0%', minWidth: 0, width: '100%' }}>
// // // //           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 4 }}>
// // // //             <Typography variant="h6" fontWeight={700} gutterBottom>
// // // //               Business Details
// // // //             </Typography>
// // // //             <Typography variant="body2" color="text.secondary" sx={{ mb: 3.5 }}>
// // // //               Provide basic information about the business
// // // //             </Typography>

// // // //             <form onSubmit={formik.handleSubmit}>
// // // //               <InlineField label="Business Name *">
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   size="medium"
// // // //                   name="businessName"
// // // //                   placeholder="Enter business name"
// // // //                   value={values.businessName}
// // // //                   onChange={handleChange}
// // // //                   onBlur={handleBlur}
// // // //                   error={touched.businessName && Boolean(errors.businessName)}
// // // //                   helperText={touched.businessName && errors.businessName}
// // // //                 />
// // // //               </InlineField>

// // // //               <InlineField label="Industry *">
// // // //                 <FormControl fullWidth size="medium" error={touched.industry && Boolean(errors.industry)}>
// // // //                   <Select
// // // //                     name="industry"
// // // //                     displayEmpty
// // // //                     value={values.industry}
// // // //                     onChange={handleChange}
// // // //                     onBlur={handleBlur}
// // // //                   >
// // // //                     <MenuItem value="" disabled>
// // // //                       Select industry
// // // //                     </MenuItem>
// // // //                     {INDUSTRIES.map((i) => (
// // // //                       <MenuItem key={i} value={i}>
// // // //                         {i}
// // // //                       </MenuItem>
// // // //                     ))}
// // // //                   </Select>
// // // //                   {touched.industry && errors.industry && (
// // // //                     <FormHelperText error>{errors.industry}</FormHelperText>
// // // //                   )}
// // // //                 </FormControl>
// // // //               </InlineField>

// // // //               <InlineField label="Contact Email *">
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   size="medium"
// // // //                   type="email"
// // // //                   name="contactEmail"
// // // //                   placeholder="business@example.com"
// // // //                   value={values.contactEmail}
// // // //                   onChange={handleChange}
// // // //                   onBlur={handleBlur}
// // // //                   error={touched.contactEmail && Boolean(errors.contactEmail)}
// // // //                   helperText={touched.contactEmail && errors.contactEmail}
// // // //                 />
// // // //               </InlineField>

// // // //               <InlineField label="Emergency Contact *">
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   size="medium"
// // // //                   name="emergencyContactNo"
// // // //                   placeholder="Digits only, e.g. 9198765432"
// // // //                   value={values.emergencyContactNo}
// // // //                   onChange={handleChange}
// // // //                   onBlur={handleBlur}
// // // //                   error={touched.emergencyContactNo && Boolean(errors.emergencyContactNo)}
// // // //                   helperText={touched.emergencyContactNo && errors.emergencyContactNo}
// // // //                 />
// // // //               </InlineField>

// // // //               <InlineField label="Website URL *">
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   size="medium"
// // // //                   type="url"
// // // //                   name="websiteUrl"
// // // //                   placeholder="https://example.com"
// // // //                   value={values.websiteUrl}
// // // //                   onChange={handleChange}
// // // //                   onBlur={handleBlur}
// // // //                   error={touched.websiteUrl && Boolean(errors.websiteUrl)}
// // // //                   helperText={touched.websiteUrl && errors.websiteUrl}
// // // //                 />
// // // //               </InlineField>

// // // //               <InlineField label="Webhook URL *">
// // // //                 <TextField
// // // //                   fullWidth
// // // //                   size="medium"
// // // //                   name="webhookUrl"
// // // //                   placeholder="https://example.com/webhook"
// // // //                   value={values.webhookUrl}
// // // //                   onChange={handleChange}
// // // //                   onBlur={handleBlur}
// // // //                   error={touched.webhookUrl && Boolean(errors.webhookUrl)}
// // // //                   helperText={touched.webhookUrl && errors.webhookUrl}
// // // //                 />
// // // //               </InlineField>

// // // //               <Divider sx={{ my: 2.5 }} />

// // // //               <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 2 }}>
// // // //                 Access & Status
// // // //               </Typography>

// // // //               <InlineField label="Account Status *">
// // // //                 <FormControl fullWidth size="medium" error={touched.accountStatus && Boolean(errors.accountStatus)}>
// // // //                   <Select name="accountStatus" value={values.accountStatus} onChange={handleChange}>
// // // //                     {Object.values(BUSINESS_STATUS).map((s) => (
// // // //                       <MenuItem key={s} value={s}>
// // // //                         {s}
// // // //                       </MenuItem>
// // // //                     ))}
// // // //                   </Select>
// // // //                   {touched.accountStatus && errors.accountStatus && (
// // // //                     <FormHelperText error>{errors.accountStatus}</FormHelperText>
// // // //                   )}
// // // //                 </FormControl>
// // // //               </InlineField>

// // // //               <InlineField label="Enable Business">
// // // //                 <Switch
// // // //                   checked={isActive}
// // // //                   onChange={(e) =>
// // // //                     setFieldValue(
// // // //                       'accountStatus',
// // // //                       e.target.checked ? BUSINESS_STATUS.ACTIVE : BUSINESS_STATUS.INACTIVE
// // // //                     )
// // // //                   }
// // // //                   color="primary"
// // // //                 />
// // // //                 <Typography variant="body2" color="text.secondary" sx={{ ml: 1, display: 'inline' }}>
// // // //                   {isActive ? 'Business will be active' : 'Business will be inactive'}
// // // //                 </Typography>
// // // //               </InlineField>
// // // //             </form>

// // // //             {/* FOOTER ACTIONS */}
// // // //             <Box
// // // //               sx={{
// // // //                 display: 'flex',
// // // //                 justifyContent: 'space-between',
// // // //                 alignItems: 'center',
// // // //                 mt: 4,
// // // //                 pt: 3,
// // // //                 borderTop: `1px solid ${C.border}`,
// // // //               }}
// // // //             >
// // // //               <Button
// // // //                 variant="outlined"
// // // //                 startIcon={<ArrowBackIcon />}
// // // //                 onClick={() => navigate('/admin/businesses')}
// // // //                 disabled={loading}
// // // //                 sx={{ borderColor: C.border, color: C.textPrimary, px: 3, py: 1 }}
// // // //               >
// // // //                 Cancel
// // // //               </Button>
// // // //               <Button
// // // //                 variant="contained"
// // // //                 onClick={formik.handleSubmit}
// // // //                 disabled={loading}
// // // //                 endIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CheckCircle />}
// // // //                 sx={{
// // // //                   background: `#2563EB`,
// // // //                   color: '#fff',
// // // //                   px: 5,
// // // //                   py: 1.5,
// // // //                 }}
// // // //               >
// // // //                 {loading ? 'Processing…' : isEditMode ? 'Update Business' : 'Create Business'}
// // // //               </Button>
// // // //             </Box>
// // // //           </Paper>
// // // //         </Box>

// // // //         {/* RIGHT — preview sidebar */}
// // // //         <Box
// // // //           sx={{
// // // //             flex: '0 0 auto',
// // // //             width: { xs: '100%', md: 520 },
// // // //             position: { md: 'sticky' },
// // // //             top: { md: 16 },
// // // //           }}
// // // //         >
// // // //           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 4 }}>
// // // //             <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2.5, fontSize: 17 }}>
// // // //               Business Preview
// // // //             </Typography>

// // // //             <Box
// // // //               sx={{
// // // //                 border: `1px solid ${C.border}`,
// // // //                 borderRadius: 2,
// // // //                 p: 3,
// // // //                 textAlign: 'center',
// // // //                 mb: 2.5,
// // // //               }}
// // // //             >
// // // //               <Box
// // // //                 sx={{
// // // //                   width: 88,
// // // //                   height: 88,
// // // //                   borderRadius: '50%',
// // // //                   bgcolor: C.indigo,
// // // //                   color: '#fff',
// // // //                   display: 'flex',
// // // //                   alignItems: 'center',
// // // //                   justifyContent: 'center',
// // // //                   fontSize: 28,
// // // //                   fontWeight: 700,
// // // //                   mx: 'auto',
// // // //                   mb: 1.5,
// // // //                 }}
// // // //               >
// // // //                 {values.businessName ? (
// // // //                   values.businessName.slice(0, 2).toUpperCase()
// // // //                 ) : (
// // // //                   <BusinessIcon sx={{ fontSize: 34 }} />
// // // //                 )}
// // // //               </Box>
// // // //               <Typography variant="h6" fontWeight={700}>
// // // //                 {values.businessName || 'Business Name'}
// // // //               </Typography>
// // // //               {values.industry && (
// // // //                 <Chip
// // // //                   label={values.industry}
// // // //                   size="small"
// // // //                   sx={{ bgcolor: C.badgeActiveBg, color: C.badgeActiveText, fontWeight: 600, my: 1 }}
// // // //                 />
// // // //               )}
// // // //               <Typography variant="body2" color="text.secondary">
// // // //                 {values.contactEmail || 'business@example.com'}
// // // //               </Typography>
// // // //             </Box>

// // // //             <Typography variant="subtitle2" fontWeight={700} color={C.blue} sx={{ mb: 1.5 }}>
// // // //               Overview
// // // //             </Typography>
// // // //             <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, p: 2 }}>
// // // //               {[
// // // //                 ['Website', values.websiteUrl || '-'],
// // // //                 ['Webhook', values.webhookUrl || '-'],
// // // //                 ['Emergency Contact', values.emergencyContactNo || '-'],
// // // //               ].map(([label, value]) => (
// // // //                 <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6, gap: 2 }}>
// // // //                   <Typography variant="body2" color="text.secondary">
// // // //                     {label}
// // // //                   </Typography>
// // // //                   <Typography
// // // //                     variant="body2"
// // // //                     fontWeight={600}
// // // //                     sx={{ textAlign: 'right', wordBreak: 'break-all' }}
// // // //                   >
// // // //                     {value}
// // // //                   </Typography>
// // // //                 </Box>
// // // //               ))}
// // // //               <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6 }}>
// // // //                 <Typography variant="body2" color="text.secondary">
// // // //                   Status
// // // //                 </Typography>
// // // //                 <StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} />
// // // //               </Box>
// // // //             </Box>

// // // //             <Box
// // // //               sx={{
// // // //                 mt: 2.5,
// // // //                 bgcolor: C.infoBg,
// // // //                 border: `1px solid ${C.infoBorder}`,
// // // //                 borderRadius: 2,
// // // //                 p: 2,
// // // //                 display: 'flex',
// // // //                 gap: 1.5,
// // // //               }}
// // // //             >
// // // //               <InfoOutlined sx={{ color: C.infoText, fontSize: 20, mt: 0.2 }} />
// // // //               <Box>
// // // //                 <Typography variant="body2" fontWeight={700} sx={{ color: C.infoText }}>
// // // //                   Good to know
// // // //                 </Typography>
// // // //                 <Typography variant="caption" sx={{ color: C.infoText }}>
// // // //                   Domains and white-label branding are configured separately, from the business's
// // // //                   detail page, after the business has been created.
// // // //                 </Typography>
// // // //               </Box>
// // // //             </Box>
// // // //           </Paper>
// // // //         </Box>
// // // //       </Box>

// // // //       {/* SNACKBAR */}
// // // //       <Snackbar
// // // //         open={snackbar.open}
// // // //         autoHideDuration={3000}
// // // //         onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
// // // //         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
// // // //       >
// // // //         <Alert
// // // //           severity={snackbar.severity}
// // // //           variant="filled"
// // // //           onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
// // // //           action={
// // // //             <IconButton size="small" color="inherit" onClick={() => setSnackbar((s) => ({ ...s, open: false }))}>
// // // //               <CloseIcon fontSize="small" />
// // // //             </IconButton>
// // // //           }
// // // //         >
// // // //           {snackbar.message}
// // // //         </Alert>
// // // //       </Snackbar>
// // // //     </Container>
// // // //   );
// // // // };

// // // // export default CreateBusiness;


// // // import React, { useEffect } from 'react';
// // // import { useNavigate } from 'react-router-dom';
// // // import { useFormik } from 'formik';
// // // import * as Yup from 'yup';
// // // import {
// // //   Container,
// // //   Box,
// // //   Typography,
// // //   Button,
// // //   TextField,
// // //   Select,
// // //   MenuItem,
// // //   FormControl,
// // //   Switch,
// // //   IconButton,
// // //   Alert,
// // //   CircularProgress,
// // //   Paper,
// // //   Grid,
// // //   Divider,
// // //   Breadcrumbs,
// // //   Link as MuiLink,
// // //   Chip,
// // //   FormHelperText,
// // //   Snackbar,
// // // } from '@mui/material';
// // // import {
// // //   ArrowBack as ArrowBackIcon,
// // //   CheckCircle,
// // //   Business as BusinessIcon,
// // //   InfoOutlined,
// // //   Close as CloseIcon,
// // // } from '@mui/icons-material';
// // // import { adminService } from '../../services/admin';
// // // import { BUSINESS_STATUS } from '../../utils/constants';

// // // /* ----------------------------------------------------------------------
// // //    Design tokens — kept consistent with CreateApplicationPage
// // // ---------------------------------------------------------------------- */
// // // const C = {
// // //   border: '#e2e8f0',
// // //   blue: '#3182ce',
// // //   blueDark: '#2b6cb0',
// // //   green: '#38a169',
// // //   greenDark: '#276749',
// // //   indigo: '#4c51bf',
// // //   textPrimary: '#1a202c',
// // //   textSecondary: '#718096',
// // //   bgLight: '#f7fafc',
// // //   badgeActiveBg: '#c6f6d5',
// // //   badgeActiveText: '#276749',
// // //   badgeInactiveBg: '#e2e8f0',
// // //   badgeInactiveText: '#4a5568',
// // //   infoBg: '#ebf8ff',
// // //   infoBorder: '#bee3f8',
// // //   infoText: '#2c5282',
// // // };

// // // const INDUSTRIES = [
// // //   'Technology', 'Finance', 'Healthcare', 'Retail', 'Education',
// // //   'Manufacturing', 'Real Estate', 'Hospitality', 'Transportation', 'Other',
// // // ];

// // // /* ----------------------------------------------------------------------
// // //    Validation schema
// // // ---------------------------------------------------------------------- */
// // // const validationSchema = Yup.object({
// // //   businessName: Yup.string()
// // //     .required('Business Name is required')
// // //     .min(2, 'Business Name must be at least 2 characters')
// // //     .max(100),
// // //   industry: Yup.string().required('Industry is required'),
// // //   contactEmail: Yup.string().email('Invalid email').required('Contact Email is required'),
// // //   emergencyContactNo: Yup.string()
// // //     .matches(/^[0-9]+$/, 'Only digits allowed')
// // //     .min(7, 'Min 7 digits')
// // //     .max(15, 'Max 15 digits')
// // //     .required('Emergency Contact is required'),
// // //   websiteUrl: Yup.string().url('Enter a valid URL').required('Website URL is required'),
// // //   webhookUrl: Yup.string().required('Webhook URL is required'),
// // //   accountStatus: Yup.string().required('Account Status is required'),
// // // });

// // // /* ----------------------------------------------------------------------
// // //    Inline field helper — label on the left, control on the right
// // //    (matches the pattern used in CreateApplicationPage)
// // // ---------------------------------------------------------------------- */
// // // const InlineField = ({ label, children, ...boxProps }) => (
// // //   <Box
// // //     sx={{
// // //       display: 'flex',
// // //       alignItems: 'flex-start',
// // //       gap: 2,
// // //       mb: 2.5,
// // //       ...boxProps.sx,
// // //     }}
// // //     {...boxProps}
// // //   >
// // //     <Typography
// // //       variant="body1"
// // //       fontWeight={600}
// // //       sx={{
// // //         minWidth: 180,
// // //         flexShrink: 0,
// // //         pt: 1,
// // //         fontSize: 15,
// // //         color: C.textPrimary,
// // //         letterSpacing: 0.1,
// // //       }}
// // //     >
// // //       {label}
// // //     </Typography>
// // //     <Box
// // //       sx={{
// // //         flex: 1,
// // //         '& .MuiInputBase-input': { fontSize: 14.5 },
// // //         '& .MuiInputBase-root': { fontSize: 14.5 },
// // //         '& .MuiFormHelperText-root': { fontSize: 12.5, mx: 0, mt: 0.5 },
// // //         '& .MuiSelect-select': { fontSize: 14.5 },
// // //       }}
// // //     >
// // //       {children}
// // //     </Box>
// // //   </Box>
// // // );

// // // const StatusBadge = ({ active, label }) => (
// // //   <Chip
// // //     label={label}
// // //     size="small"
// // //     sx={{
// // //       fontWeight: 700,
// // //       fontSize: 11,
// // //       height: 22,
// // //       bgcolor: active ? C.badgeActiveBg : C.badgeInactiveBg,
// // //       color: active ? C.badgeActiveText : C.badgeInactiveText,
// // //     }}
// // //   />
// // // );

// // // /* ----------------------------------------------------------------------
// // //    Main Component
// // // ---------------------------------------------------------------------- */
// // // const CreateBusiness = ({ business, isEditMode = false, onSuccess }) => {
// // //   const navigate = useNavigate();
// // //   const [loading, setLoading] = React.useState(false);
// // //   const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'error' });

// // //   const showSnackbar = (message, severity = 'error') =>
// // //     setSnackbar({ open: true, message, severity });

// // //   const formik = useFormik({
// // //     initialValues: {
// // //       businessName: '',
// // //       industry: '',
// // //       contactEmail: '',
// // //       emergencyContactNo: '',
// // //       websiteUrl: '',
// // //       webhookUrl: '',
// // //       accountStatus: BUSINESS_STATUS.ACTIVE,
// // //     },
// // //     validationSchema,
// // //     onSubmit: async (values) => {
// // //       try {
// // //         setLoading(true);
// // //         if (isEditMode) {
// // //           await adminService.updateBusiness(business._id, values);
// // //           showSnackbar('Business updated!', 'success');
// // //         } else {
// // //           await adminService.createBusiness(values);
// // //           showSnackbar('Business created!', 'success');
// // //         }
// // //         setTimeout(() => onSuccess?.(), 1000);
// // //       } catch (err) {
// // //         showSnackbar(err.message || 'Something went wrong');
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     },
// // //   });

// // //   const { values, handleChange, handleBlur, setFieldValue, errors, touched } = formik;

// // //   useEffect(() => {
// // //     if (!isEditMode || !business) return;
// // //     formik.setValues({
// // //       businessName: business.businessName || '',
// // //       industry: business.industry || '',
// // //       contactEmail: business.contactEmail || '',
// // //       emergencyContactNo: business.emergencyContactNo || '',
// // //       websiteUrl: business.websiteUrl || '',
// // //       webhookUrl: business.webhookUrl || '',
// // //       accountStatus: business.accountStatus || BUSINESS_STATUS.ACTIVE,
// // //     });
// // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // //   }, [isEditMode, business?._id]);

// // //   const isActive = values.accountStatus === BUSINESS_STATUS.ACTIVE;

// // //   return (
// // //     <Container maxWidth={false} sx={{ py: 3, px: { xs: 2, sm: 3, md: 5 } }}>
// // //       {/* HEADER */}
// // //       <Box sx={{ mb: 3 }}>
// // //         <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
// // //           <MuiLink
// // //             underline="hover"
// // //             color="text.secondary"
// // //             href="#"
// // //             onClick={(e) => {
// // //               e.preventDefault();
// // //               navigate('/admin/businesses');
// // //             }}
// // //           >
// // //             Businesses
// // //           </MuiLink>
// // //           <Typography color="text.primary" fontSize={13} fontWeight={600}>
// // //             {isEditMode ? 'Edit Business' : 'Create Business'}
// // //           </Typography>
// // //         </Breadcrumbs>

// // //         <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
// // //           <Typography variant="h4" fontWeight={800} sx={{ color: C.textPrimary, fontSize: { xs: 24, md: 28 } }}>
// // //             {isEditMode ? 'Edit Business' : 'Create New Business'}
// // //           </Typography>
// // //           <Typography variant="body1" color="text.secondary" sx={{ fontSize: 15 }}>
// // //             {isEditMode ? 'Update business information' : 'Add a new business account'}
// // //           </Typography>
// // //         </Box>
// // //       </Box>

// // //       {/* MAIN LAYOUT */}
// // //       <Box
// // //         sx={{
// // //           display: 'flex',
// // //           flexDirection: { xs: 'column', md: 'row' },
// // //           alignItems: 'flex-start',
// // //           gap: 3,
// // //         }}
// // //       >
// // //         {/* LEFT — form */}
// // //         <Box sx={{ flex: '1 1 0%', minWidth: 0, width: '100%' }}>
// // //           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 4 }}>
// // //             <Typography variant="h6" fontWeight={700} gutterBottom>
// // //               Business Details
// // //             </Typography>
// // //             <Typography variant="body2" color="text.secondary" sx={{ mb: 3.5 }}>
// // //               Provide basic information about the business
// // //             </Typography>

// // //             <form onSubmit={formik.handleSubmit}>
// // //               <InlineField label="Business Name *">
// // //                 <TextField
// // //                   fullWidth
// // //                   size="medium"
// // //                   name="businessName"
// // //                   placeholder="Enter business name"
// // //                   value={values.businessName}
// // //                   onChange={handleChange}
// // //                   onBlur={handleBlur}
// // //                   error={touched.businessName && Boolean(errors.businessName)}
// // //                   helperText={touched.businessName && errors.businessName}
// // //                 />
// // //               </InlineField>

// // //               <InlineField label="Industry *">
// // //                 <FormControl fullWidth size="medium" error={touched.industry && Boolean(errors.industry)}>
// // //                   <Select
// // //                     name="industry"
// // //                     displayEmpty
// // //                     value={values.industry}
// // //                     onChange={handleChange}
// // //                     onBlur={handleBlur}
// // //                   >
// // //                     <MenuItem value="" disabled>
// // //                       Select industry
// // //                     </MenuItem>
// // //                     {INDUSTRIES.map((i) => (
// // //                       <MenuItem key={i} value={i}>
// // //                         {i}
// // //                       </MenuItem>
// // //                     ))}
// // //                   </Select>
// // //                   {touched.industry && errors.industry && (
// // //                     <FormHelperText error>{errors.industry}</FormHelperText>
// // //                   )}
// // //                 </FormControl>
// // //               </InlineField>

// // //               <InlineField label="Contact Email *">
// // //                 <TextField
// // //                   fullWidth
// // //                   size="medium"
// // //                   type="email"
// // //                   name="contactEmail"
// // //                   placeholder="business@example.com"
// // //                   value={values.contactEmail}
// // //                   onChange={handleChange}
// // //                   onBlur={handleBlur}
// // //                   error={touched.contactEmail && Boolean(errors.contactEmail)}
// // //                   helperText={touched.contactEmail && errors.contactEmail}
// // //                 />
// // //               </InlineField>

// // //               <InlineField label="Emergency Contact *">
// // //                 <TextField
// // //                   fullWidth
// // //                   size="medium"
// // //                   name="emergencyContactNo"
// // //                   placeholder="Digits only, e.g. 9198765432"
// // //                   value={values.emergencyContactNo}
// // //                   onChange={handleChange}
// // //                   onBlur={handleBlur}
// // //                   error={touched.emergencyContactNo && Boolean(errors.emergencyContactNo)}
// // //                   helperText={touched.emergencyContactNo && errors.emergencyContactNo}
// // //                 />
// // //               </InlineField>

// // //               <InlineField label="Website URL *">
// // //                 <TextField
// // //                   fullWidth
// // //                   size="medium"
// // //                   type="url"
// // //                   name="websiteUrl"
// // //                   placeholder="https://example.com"
// // //                   value={values.websiteUrl}
// // //                   onChange={handleChange}
// // //                   onBlur={handleBlur}
// // //                   error={touched.websiteUrl && Boolean(errors.websiteUrl)}
// // //                   helperText={touched.websiteUrl && errors.websiteUrl}
// // //                 />
// // //               </InlineField>

// // //               <InlineField label="Webhook URL *">
// // //                 <TextField
// // //                   fullWidth
// // //                   size="medium"
// // //                   name="webhookUrl"
// // //                   placeholder="https://example.com/webhook"
// // //                   value={values.webhookUrl}
// // //                   onChange={handleChange}
// // //                   onBlur={handleBlur}
// // //                   error={touched.webhookUrl && Boolean(errors.webhookUrl)}
// // //                   helperText={touched.webhookUrl && errors.webhookUrl}
// // //                 />
// // //               </InlineField>

// // //               <Divider sx={{ my: 2.5 }} />

// // //               <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 2 }}>
// // //                 Access & Status
// // //               </Typography>

// // //               <InlineField label="Account Status *">
// // //                 <FormControl fullWidth size="medium" error={touched.accountStatus && Boolean(errors.accountStatus)}>
// // //                   <Select name="accountStatus" value={values.accountStatus} onChange={handleChange}>
// // //                     {Object.values(BUSINESS_STATUS).map((s) => (
// // //                       <MenuItem key={s} value={s}>
// // //                         {s}
// // //                       </MenuItem>
// // //                     ))}
// // //                   </Select>
// // //                   {touched.accountStatus && errors.accountStatus && (
// // //                     <FormHelperText error>{errors.accountStatus}</FormHelperText>
// // //                   )}
// // //                 </FormControl>
// // //               </InlineField>

// // //               <InlineField label="Enable Business">
// // //                 <Switch
// // //                   checked={isActive}
// // //                   onChange={(e) =>
// // //                     setFieldValue(
// // //                       'accountStatus',
// // //                       e.target.checked ? BUSINESS_STATUS.ACTIVE : BUSINESS_STATUS.INACTIVE
// // //                     )
// // //                   }
// // //                   color="primary"
// // //                 />
// // //                 <Typography variant="body2" color="text.secondary" sx={{ ml: 1, display: 'inline' }}>
// // //                   {isActive ? 'Business will be active' : 'Business will be inactive'}
// // //                 </Typography>
// // //               </InlineField>
// // //             </form>

// // //             {/* FOOTER ACTIONS */}
// // //             <Box
// // //               sx={{
// // //                 display: 'flex',
// // //                 justifyContent: 'space-between',
// // //                 alignItems: 'center',
// // //                 mt: 4,
// // //                 pt: 3,
// // //                 borderTop: `1px solid ${C.border}`,
// // //               }}
// // //             >
// // //               <Button
// // //                 variant="outlined"
// // //                 startIcon={<ArrowBackIcon />}
// // //                 onClick={() => navigate('/admin/businesses')}
// // //                 disabled={loading}
// // //                 sx={{ borderColor: C.border, color: C.textPrimary, px: 3, py: 1 }}
// // //               >
// // //                 Cancel
// // //               </Button>
// // //               <Button
// // //                 variant="contained"
// // //                 onClick={formik.handleSubmit}
// // //                 disabled={loading}
// // //                 endIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CheckCircle />}
// // //                 sx={{
// // //                   background: `#2563EB`,
// // //                   color: '#fff',
// // //                   px: 5,
// // //                   py: 1.5,
// // //                 }}
// // //               >
// // //                 {loading ? 'Processing…' : isEditMode ? 'Update Business' : 'Create Business'}
// // //               </Button>
// // //             </Box>
// // //           </Paper>
// // //         </Box>

// // //         {/* RIGHT — preview sidebar */}
// // //         <Box
// // //           sx={{
// // //             flex: '0 0 auto',
// // //             width: { xs: '100%', md: 520 },
// // //             position: { md: 'sticky' },
// // //             top: { md: 16 },
// // //           }}
// // //         >
// // //           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 4 }}>
// // //             <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2.5, fontSize: 17 }}>
// // //               Business Preview
// // //             </Typography>

// // //             <Box
// // //               sx={{
// // //                 border: `1px solid ${C.border}`,
// // //                 borderRadius: 2,
// // //                 p: 3,
// // //                 textAlign: 'center',
// // //                 mb: 2.5,
// // //               }}
// // //             >
// // //               <Box
// // //                 sx={{
// // //                   width: 88,
// // //                   height: 88,
// // //                   borderRadius: '50%',
// // //                   bgcolor: C.indigo,
// // //                   color: '#fff',
// // //                   display: 'flex',
// // //                   alignItems: 'center',
// // //                   justifyContent: 'center',
// // //                   fontSize: 28,
// // //                   fontWeight: 700,
// // //                   mx: 'auto',
// // //                   mb: 1.5,
// // //                 }}
// // //               >
// // //                 {values.businessName ? (
// // //                   values.businessName.slice(0, 2).toUpperCase()
// // //                 ) : (
// // //                   <BusinessIcon sx={{ fontSize: 34 }} />
// // //                 )}
// // //               </Box>
// // //               <Typography variant="h6" fontWeight={700}>
// // //                 {values.businessName || 'Business Name'}
// // //               </Typography>
// // //               {values.industry && (
// // //                 <Chip
// // //                   label={values.industry}
// // //                   size="small"
// // //                   sx={{ bgcolor: C.badgeActiveBg, color: C.badgeActiveText, fontWeight: 600, my: 1 }}
// // //                 />
// // //               )}
// // //               <Typography variant="body2" color="text.secondary">
// // //                 {values.contactEmail || 'business@example.com'}
// // //               </Typography>
// // //             </Box>

// // //             <Typography variant="subtitle2" fontWeight={700} color={C.blue} sx={{ mb: 1.5 }}>
// // //               Overview
// // //             </Typography>
// // //             <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, p: 2 }}>
// // //               {[
// // //                 ['Website', values.websiteUrl || '-'],
// // //                 ['Webhook', values.webhookUrl || '-'],
// // //                 ['Emergency Contact', values.emergencyContactNo || '-'],
// // //               ].map(([label, value]) => (
// // //                 <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6, gap: 2 }}>
// // //                   <Typography variant="body2" color="text.secondary">
// // //                     {label}
// // //                   </Typography>
// // //                   <Typography
// // //                     variant="body2"
// // //                     fontWeight={600}
// // //                     sx={{ textAlign: 'right', wordBreak: 'break-all' }}
// // //                   >
// // //                     {value}
// // //                   </Typography>
// // //                 </Box>
// // //               ))}
// // //               <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6 }}>
// // //                 <Typography variant="body2" color="text.secondary">
// // //                   Status
// // //                 </Typography>
// // //                 <StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} />
// // //               </Box>
// // //             </Box>

// // //             <Box
// // //               sx={{
// // //                 mt: 2.5,
// // //                 bgcolor: C.infoBg,
// // //                 border: `1px solid ${C.infoBorder}`,
// // //                 borderRadius: 2,
// // //                 p: 2,
// // //                 display: 'flex',
// // //                 gap: 1.5,
// // //               }}
// // //             >
// // //               <InfoOutlined sx={{ color: C.infoText, fontSize: 20, mt: 0.2 }} />
// // //               <Box>
// // //                 <Typography variant="body2" fontWeight={700} sx={{ color: C.infoText }}>
// // //                   Good to know
// // //                 </Typography>
// // //                 <Typography variant="caption" sx={{ color: C.infoText }}>
// // //                   Domains and white-label branding are configured separately, from the business's
// // //                   detail page, after the business has been created.
// // //                 </Typography>
// // //               </Box>
// // //             </Box>
// // //           </Paper>
// // //         </Box>
// // //       </Box>

// // //       {/* SNACKBAR */}
// // //       <Snackbar
// // //         open={snackbar.open}
// // //         autoHideDuration={3000}
// // //         onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
// // //         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
// // //       >
// // //         <Alert
// // //           severity={snackbar.severity}
// // //           variant="filled"
// // //           onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
// // //           action={
// // //             <IconButton size="small" color="inherit" onClick={() => setSnackbar((s) => ({ ...s, open: false }))}>
// // //               <CloseIcon fontSize="small" />
// // //             </IconButton>
// // //           }
// // //         >
// // //           {snackbar.message}
// // //         </Alert>
// // //       </Snackbar>
// // //     </Container>
// // //   );
// // // };

// // // export default CreateBusiness;


// // import React, { useEffect } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { useFormik } from 'formik';
// // import * as Yup from 'yup';
// // import {
// //   Container,
// //   Box,
// //   Typography,
// //   Button,
// //   TextField,
// //   Select,
// //   MenuItem,
// //   FormControl,
// //   Switch,
// //   IconButton,
// //   Alert,
// //   CircularProgress,
// //   Paper,
// //   Grid,
// //   Divider,
// //   Breadcrumbs,
// //   Link as MuiLink,
// //   Chip,
// //   FormHelperText,
// //   Snackbar,
// //   Avatar,
// // } from '@mui/material';
// // import {
// //   ArrowBack as ArrowBackIcon,
// //   CheckCircle,
// //   Business as BusinessIcon,
// //   InfoOutlined,
// //   Close as CloseIcon,
// //   Language as LanguageIcon,
// //   Lock as LockIcon,
// //   Public as PublicIcon,
// // } from '@mui/icons-material';
// // import { adminService } from '../../services/admin';
// // import { BUSINESS_STATUS } from '../../utils/constants';

// // /* ----------------------------------------------------------------------
// //    Design tokens – kept consistent with CreateApplicationPage
// // ---------------------------------------------------------------------- */
// // const C = {
// //   border: '#e2e8f0',
// //   blue: '#3182ce',
// //   blueDark: '#2b6cb0',
// //   green: '#38a169',
// //   greenDark: '#276749',
// //   indigo: '#4c51bf',
// //   textPrimary: '#1a202c',
// //   textSecondary: '#718096',
// //   bgLight: '#f7fafc',
// //   badgeActiveBg: '#c6f6d5',
// //   badgeActiveText: '#276749',
// //   badgeInactiveBg: '#e2e8f0',
// //   badgeInactiveText: '#4a5568',
// //   infoBg: '#ebf8ff',
// //   infoBorder: '#bee3f8',
// //   infoText: '#2c5282',
// // };

// // const INDUSTRIES = [
// //   'Technology', 'Finance', 'Healthcare', 'Retail', 'Education',
// //   'Manufacturing', 'Real Estate', 'Hospitality', 'Transportation', 'Other',
// // ];

// // /* ----------------------------------------------------------------------
// //    Validation schema (unchanged)
// // ---------------------------------------------------------------------- */
// // const validationSchema = Yup.object({
// //   businessName: Yup.string()
// //     .required('Business Name is required')
// //     .min(2, 'Business Name must be at least 2 characters')
// //     .max(100),
// //   industry: Yup.string().required('Industry is required'),
// //   contactEmail: Yup.string().email('Invalid email').required('Contact Email is required'),
// //   emergencyContactNo: Yup.string()
// //     .matches(/^[0-9]+$/, 'Only digits allowed')
// //     .min(7, 'Min 7 digits')
// //     .max(15, 'Max 15 digits')
// //     .required('Emergency Contact is required'),
// //   websiteUrl: Yup.string().url('Enter a valid URL').required('Website URL is required'),
// //   webhookUrl: Yup.string().required('Webhook URL is required'),
// //   accountStatus: Yup.string().required('Account Status is required'),
// // });

// // /* ----------------------------------------------------------------------
// //    Reusable UI components – exactly the same as in CreateApplicationPage
// // ---------------------------------------------------------------------- */
// // const StatusBadge = ({ active, label }) => (
// //   <Chip
// //     label={label}
// //     size="small"
// //     sx={{
// //       fontWeight: 700,
// //       fontSize: 11,
// //       height: 22,
// //       bgcolor: active ? C.badgeActiveBg : C.badgeInactiveBg,
// //       color: active ? C.badgeActiveText : C.badgeInactiveText,
// //     }}
// //   />
// // );

// // const FieldLabel = ({ children }) => (
// //   <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
// //     {children}
// //   </Typography>
// // );

// // const SectionCard = ({ icon, title, badge, children, sx }) => (
// //   <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, overflow: 'hidden', mb: 2, ...sx }}>
// //     <Box
// //       sx={{
// //         display: 'flex',
// //         alignItems: 'center',
// //         justifyContent: 'space-between',
// //         px: 2.5,
// //         py: 1.5,
// //         bgcolor: '#fafbfc',
// //         flexWrap: 'wrap',
// //         gap: 1,
// //       }}
// //     >
// //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
// //         {icon && (
// //           <Avatar variant="rounded" sx={{ width: 36, height: 36, bgcolor: C.indigo, color: '#fff', flexShrink: 0 }}>
// //             {icon}
// //           </Avatar>
// //         )}
// //         <Typography variant="body1" fontWeight={700} noWrap>
// //           {title}
// //         </Typography>
// //       </Box>
// //       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
// //         {badge}
// //       </Box>
// //     </Box>
// //     <Box sx={{ p: 2.5 }}>{children}</Box>
// //   </Box>
// // );

// // /* ----------------------------------------------------------------------
// //    Main Component
// // ---------------------------------------------------------------------- */
// // const CreateBusiness = ({ business, isEditMode = false, onSuccess }) => {
// //   const navigate = useNavigate();
// //   const [loading, setLoading] = React.useState(false);
// //   const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'error' });

// //   const showSnackbar = (message, severity = 'error') =>
// //     setSnackbar({ open: true, message, severity });

// //   const formik = useFormik({
// //     initialValues: {
// //       businessName: '',
// //       industry: '',
// //       contactEmail: '',
// //       emergencyContactNo: '',
// //       websiteUrl: '',
// //       webhookUrl: '',
// //       accountStatus: BUSINESS_STATUS.ACTIVE,
// //     },
// //     validationSchema,
// //     onSubmit: async (values) => {
// //       try {
// //         setLoading(true);
// //         if (isEditMode) {
// //           await adminService.updateBusiness(business._id, values);
// //           showSnackbar('Business updated!', 'success');
// //         } else {
// //           await adminService.createBusiness(values);
// //           showSnackbar('Business created!', 'success');
// //         }
// //         setTimeout(() => onSuccess?.(), 1000);
// //       } catch (err) {
// //         showSnackbar(err.message || 'Something went wrong');
// //       } finally {
// //         setLoading(false);
// //       }
// //     },
// //   });

// //   const { values, handleChange, handleBlur, setFieldValue, errors, touched } = formik;

// //   useEffect(() => {
// //     if (!isEditMode || !business) return;
// //     formik.setValues({
// //       businessName: business.businessName || '',
// //       industry: business.industry || '',
// //       contactEmail: business.contactEmail || '',
// //       emergencyContactNo: business.emergencyContactNo || '',
// //       websiteUrl: business.websiteUrl || '',
// //       webhookUrl: business.webhookUrl || '',
// //       accountStatus: business.accountStatus || BUSINESS_STATUS.ACTIVE,
// //     });
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, [isEditMode, business?._id]);

// //   const isActive = values.accountStatus === BUSINESS_STATUS.ACTIVE;

// //   return (
// //     <Container maxWidth={false} sx={{ py: 3, px: { xs: 2, sm: 3, md: 5 } }}>
// //       {/* HEADER */}
// //       <Box sx={{ mb: 3 }}>
// //         <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
// //           <MuiLink
// //             underline="hover"
// //             color="text.secondary"
// //             href="#"
// //             onClick={(e) => {
// //               e.preventDefault();
// //               navigate('/admin/businesses');
// //             }}
// //           >
// //             Businesses
// //           </MuiLink>
// //           <Typography color="text.primary" fontSize={13} fontWeight={600}>
// //             {isEditMode ? 'Edit Business' : 'Create Business'}
// //           </Typography>
// //         </Breadcrumbs>

// //         <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
// //           <Typography variant="h5" fontWeight={800} sx={{ color: C.textPrimary, fontSize: { xs: 24, md: 28 } }}>
// //             {isEditMode ? 'Edit Business' : 'Create New Business'}
// //           </Typography>
// //           <Typography variant="body2" color="text.secondary" sx={{ fontSize: 15 }}>
// //             {isEditMode ? 'Update business information' : 'Add a new business account'}
// //           </Typography>
// //         </Box>
// //       </Box>

// //       {/* MAIN LAYOUT – left form + right preview */}
// //       <Box
// //         sx={{
// //           display: 'flex',
// //           flexDirection: { xs: 'column', md: 'row' },
// //           alignItems: 'flex-start',
// //           gap: 3,
// //         }}
// //       >
// //         {/* LEFT – form */}
// //         <Box sx={{ flex: '1 1 0%', minWidth: 0, width: '100%' }}>
// //           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
// //             <form onSubmit={formik.handleSubmit}>
// //               {/* Basic Information */}
// //               <SectionCard
// //                 icon={<BusinessIcon fontSize="small" />}
// //                 title="Business Details"
// //                 badge={<StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} />}
// //               >
// //                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
// //                   <Box>
// //                     <FieldLabel>Business Name *</FieldLabel>
// //                     <TextField
// //                       fullWidth
// //                       size="medium"
// //                       name="businessName"
// //                       placeholder="Enter business name"
// //                       value={values.businessName}
// //                       onChange={handleChange}
// //                       onBlur={handleBlur}
// //                       error={touched.businessName && Boolean(errors.businessName)}
// //                       helperText={touched.businessName && errors.businessName}
// //                     />
// //                   </Box>

// //                   <Box>
// //                     <FieldLabel>Industry *</FieldLabel>
// //                     <FormControl fullWidth size="medium" error={touched.industry && Boolean(errors.industry)}>
// //                       <Select
// //                         name="industry"
// //                         displayEmpty
// //                         value={values.industry}
// //                         onChange={handleChange}
// //                         onBlur={handleBlur}
// //                       >
// //                         <MenuItem value="" disabled>Select industry</MenuItem>
// //                         {INDUSTRIES.map((i) => (
// //                           <MenuItem key={i} value={i}>{i}</MenuItem>
// //                         ))}
// //                       </Select>
// //                       {touched.industry && errors.industry && (
// //                         <FormHelperText error>{errors.industry}</FormHelperText>
// //                       )}
// //                     </FormControl>
// //                   </Box>

// //                   <Box>
// //                     <FieldLabel>Contact Email *</FieldLabel>
// //                     <TextField
// //                       fullWidth
// //                       size="medium"
// //                       type="email"
// //                       name="contactEmail"
// //                       placeholder="business@example.com"
// //                       value={values.contactEmail}
// //                       onChange={handleChange}
// //                       onBlur={handleBlur}
// //                       error={touched.contactEmail && Boolean(errors.contactEmail)}
// //                       helperText={touched.contactEmail && errors.contactEmail}
// //                     />
// //                   </Box>

// //                   <Box>
// //                     <FieldLabel>Emergency Contact *</FieldLabel>
// //                     <TextField
// //                       fullWidth
// //                       size="medium"
// //                       name="emergencyContactNo"
// //                       placeholder="Digits only, e.g. 9198765432"
// //                       value={values.emergencyContactNo}
// //                       onChange={handleChange}
// //                       onBlur={handleBlur}
// //                       error={touched.emergencyContactNo && Boolean(errors.emergencyContactNo)}
// //                       helperText={touched.emergencyContactNo && errors.emergencyContactNo}
// //                     />
// //                   </Box>

// //                   <Box>
// //                     <FieldLabel>Website URL *</FieldLabel>
// //                     <TextField
// //                       fullWidth
// //                       size="medium"
// //                       type="url"
// //                       name="websiteUrl"
// //                       placeholder="https://example.com"
// //                       value={values.websiteUrl}
// //                       onChange={handleChange}
// //                       onBlur={handleBlur}
// //                       error={touched.websiteUrl && Boolean(errors.websiteUrl)}
// //                       helperText={touched.websiteUrl && errors.websiteUrl}
// //                     />
// //                   </Box>

// //                   <Box>
// //                     <FieldLabel>Webhook URL *</FieldLabel>
// //                     <TextField
// //                       fullWidth
// //                       size="medium"
// //                       name="webhookUrl"
// //                       placeholder="https://example.com/webhook"
// //                       value={values.webhookUrl}
// //                       onChange={handleChange}
// //                       onBlur={handleBlur}
// //                       error={touched.webhookUrl && Boolean(errors.webhookUrl)}
// //                       helperText={touched.webhookUrl && errors.webhookUrl}
// //                     />
// //                   </Box>
// //                 </Box>
// //               </SectionCard>

// //               {/* Access & Status */}
// //               <SectionCard
// //                 icon={<LockIcon fontSize="small" />}
// //                 title="Access & Status"
// //                 badge={<StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} />}
// //               >
// //                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
// //                   <Box>
// //                     <FieldLabel>Account Status *</FieldLabel>
// //                     <FormControl fullWidth size="medium" error={touched.accountStatus && Boolean(errors.accountStatus)}>
// //                       <Select name="accountStatus" value={values.accountStatus} onChange={handleChange}>
// //                         {Object.values(BUSINESS_STATUS).map((s) => (
// //                           <MenuItem key={s} value={s}>{s}</MenuItem>
// //                         ))}
// //                       </Select>
// //                       {touched.accountStatus && errors.accountStatus && (
// //                         <FormHelperText error>{errors.accountStatus}</FormHelperText>
// //                       )}
// //                     </FormControl>
// //                   </Box>

// //                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
// //                     <Switch
// //                       checked={isActive}
// //                       onChange={(e) =>
// //                         setFieldValue(
// //                           'accountStatus',
// //                           e.target.checked ? BUSINESS_STATUS.ACTIVE : BUSINESS_STATUS.INACTIVE
// //                         )
// //                       }
// //                       color="primary"
// //                     />
// //                     <Typography variant="body2" color="text.secondary">
// //                       {isActive ? 'Business will be active' : 'Business will be inactive'}
// //                     </Typography>
// //                   </Box>
// //                 </Box>
// //               </SectionCard>

// //               {/* FOOTER ACTIONS */}
// //               <Box
// //                 sx={{
// //                   display: 'flex',
// //                   justifyContent: 'space-between',
// //                   alignItems: 'center',
// //                   mt: 4,
// //                   pt: 3,
// //                   borderTop: `1px solid ${C.border}`,
// //                 }}
// //               >
// //                 <Button
// //                   variant="outlined"
// //                   startIcon={<ArrowBackIcon />}
// //                   onClick={() => navigate('/admin/businesses')}
// //                   disabled={loading}
// //                   sx={{ borderColor: C.border, color: C.textPrimary, px: 3, py: 1 }}
// //                 >
// //                   Cancel
// //                 </Button>
// //                 <Button
// //                   variant="contained"
// //                   onClick={formik.handleSubmit}
// //                   disabled={loading}
// //                   endIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CheckCircle />}
// //                   sx={{
// //                     background: `#2563EB`,
// //                     color: '#fff',
// //                     px: 5,
// //                     py: 1.5,
// //                   }}
// //                 >
// //                   {loading ? 'Processing…' : isEditMode ? 'Update Business' : 'Create Business'}
// //                 </Button>
// //               </Box>
// //             </form>
// //           </Paper>
// //         </Box>

// //         {/* RIGHT – preview sidebar (sticky) */}
// //         <Box
// //           sx={{
// //             flex: '0 0 auto',
// //             width: { xs: '100%', md: 520 },
// //             position: { md: 'sticky' },
// //             top: { md: 16 },
// //           }}
// //         >
// //           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
// //             <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
// //               Business Preview
// //             </Typography>

// //             <Box
// //               sx={{
// //                 border: `1px solid ${C.border}`,
// //                 borderRadius: 2,
// //                 p: 3,
// //                 textAlign: 'center',
// //                 mb: 2.5,
// //               }}
// //             >
// //               <Box
// //                 sx={{
// //                   width: 88,
// //                   height: 88,
// //                   borderRadius: '50%',
// //                   bgcolor: C.indigo,
// //                   color: '#fff',
// //                   display: 'flex',
// //                   alignItems: 'center',
// //                   justifyContent: 'center',
// //                   fontSize: 28,
// //                   fontWeight: 700,
// //                   mx: 'auto',
// //                   mb: 1.5,
// //                   overflow: 'hidden',
// //                 }}
// //               >
// //                 {values.businessName ? (
// //                   values.businessName.slice(0, 2).toUpperCase()
// //                 ) : (
// //                   <BusinessIcon sx={{ fontSize: 34 }} />
// //                 )}
// //               </Box>
// //               <Typography variant="h6" fontWeight={700}>
// //                 {values.businessName || 'Business Name'}
// //               </Typography>
// //               {values.industry && (
// //                 <Chip
// //                   label={values.industry}
// //                   size="small"
// //                   sx={{ bgcolor: C.badgeActiveBg, color: C.badgeActiveText, fontWeight: 600, my: 1 }}
// //                 />
// //               )}
// //               <Typography variant="body2" color="text.secondary">
// //                 {values.contactEmail || 'business@example.com'}
// //               </Typography>
// //             </Box>

// //             <Typography variant="subtitle2" fontWeight={700} color={C.blue} sx={{ mb: 1.5 }}>
// //               Overview
// //             </Typography>
// //             <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, p: 2 }}>
// //               {[
// //                 ['Website', values.websiteUrl || '-'],
// //                 ['Webhook', values.webhookUrl || '-'],
// //                 ['Emergency Contact', values.emergencyContactNo || '-'],
// //               ].map(([label, value]) => (
// //                 <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6, gap: 2 }}>
// //                   <Typography variant="body2" color="text.secondary">{label}</Typography>
// //                   <Typography variant="body2" fontWeight={600} sx={{ textAlign: 'right', wordBreak: 'break-all' }}>
// //                     {value}
// //                   </Typography>
// //                 </Box>
// //               ))}
// //               <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6 }}>
// //                 <Typography variant="body2" color="text.secondary">Status</Typography>
// //                 <StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} />
// //               </Box>
// //             </Box>

// //             <Box
// //               sx={{
// //                 mt: 2.5,
// //                 bgcolor: C.infoBg,
// //                 border: `1px solid ${C.infoBorder}`,
// //                 borderRadius: 2,
// //                 p: 2,
// //                 display: 'flex',
// //                 gap: 1.5,
// //               }}
// //             >
// //               <InfoOutlined sx={{ color: C.infoText, fontSize: 20, mt: 0.2 }} />
// //               <Box>
// //                 <Typography variant="body2" fontWeight={700} sx={{ color: C.infoText }}>
// //                   Good to know
// //                 </Typography>
// //                 <Typography variant="caption" sx={{ color: C.infoText }}>
// //                   Domains and white-label branding are configured separately, from the business's
// //                   detail page, after the business has been created.
// //                 </Typography>
// //               </Box>
// //             </Box>
// //           </Paper>
// //         </Box>
// //       </Box>

// //       {/* SNACKBAR */}
// //       <Snackbar
// //         open={snackbar.open}
// //         autoHideDuration={3000}
// //         onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
// //         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
// //       >
// //         <Alert
// //           severity={snackbar.severity}
// //           variant="filled"
// //           onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
// //           action={
// //             <IconButton size="small" color="inherit" onClick={() => setSnackbar((s) => ({ ...s, open: false }))}>
// //               <CloseIcon fontSize="small" />
// //             </IconButton>
// //           }
// //         >
// //           {snackbar.message}
// //         </Alert>
// //       </Snackbar>
// //     </Container>
// //   );
// // };

// // export default CreateBusiness;

// import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import {
//   Container,
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   FormControl,
//   Switch,
//   IconButton,
//   Alert,
//   CircularProgress,
//   Paper,
//   Breadcrumbs,
//   Link as MuiLink,
//   Chip,
//   FormHelperText,
//   Snackbar,
//   Avatar,
// } from '@mui/material';
// import {
//   ArrowBack as ArrowBackIcon,
//   CheckCircle,
//   Business as BusinessIcon,
//   InfoOutlined,
//   Close as CloseIcon,
//   Lock as LockIcon,
// } from '@mui/icons-material';
// import { adminService } from '../../services/admin';
// import { BUSINESS_STATUS } from '../../utils/constants';

// /* ----------------------------------------------------------------------
//    Design tokens – consistent with CreateApplicationPage
// ---------------------------------------------------------------------- */
// const C = {
//   border: '#e2e8f0',
//   blue: '#3182ce',
//   blueDark: '#2b6cb0',
//   green: '#38a169',
//   greenDark: '#276749',
//   indigo: '#4c51bf',
//   textPrimary: '#1a202c',
//   textSecondary: '#718096',
//   bgLight: '#f7fafc',
//   badgeActiveBg: '#c6f6d5',
//   badgeActiveText: '#276749',
//   badgeInactiveBg: '#e2e8f0',
//   badgeInactiveText: '#4a5568',
//   infoBg: '#ebf8ff',
//   infoBorder: '#bee3f8',
//   infoText: '#2c5282',
// };

// const INDUSTRIES = [
//   'Technology', 'Finance', 'Healthcare', 'Retail', 'Education',
//   'Manufacturing', 'Real Estate', 'Hospitality', 'Transportation', 'Other',
// ];

// /* ----------------------------------------------------------------------
//    Validation schema (unchanged)
// ---------------------------------------------------------------------- */
// const validationSchema = Yup.object({
//   businessName: Yup.string()
//     .required('Business Name is required')
//     .min(2, 'Business Name must be at least 2 characters')
//     .max(100),
//   industry: Yup.string().required('Industry is required'),
//   contactEmail: Yup.string().email('Invalid email').required('Contact Email is required'),
//   emergencyContactNo: Yup.string()
//     .matches(/^[0-9]+$/, 'Only digits allowed')
//     .min(7, 'Min 7 digits')
//     .max(15, 'Max 15 digits')
//     .required('Emergency Contact is required'),
//   websiteUrl: Yup.string().url('Enter a valid URL').required('Website URL is required'),
//   webhookUrl: Yup.string().required('Webhook URL is required'),
//   accountStatus: Yup.string().required('Account Status is required'),
// });

// /* ----------------------------------------------------------------------
//    Reusable UI components – shared with CreateApplicationPage
// ---------------------------------------------------------------------- */
// const StatusBadge = ({ active, label }) => (
//   <Chip
//     label={label}
//     size="small"
//     sx={{
//       fontWeight: 700,
//       fontSize: 11,
//       height: 22,
//       bgcolor: active ? C.badgeActiveBg : C.badgeInactiveBg,
//       color: active ? C.badgeActiveText : C.badgeInactiveText,
//     }}
//   />
// );

// const FieldLabel = ({ children }) => (
//   <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
//     {children}
//   </Typography>
// );

// const SectionCard = ({ icon, title, badge, children, sx }) => (
//   <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, overflow: 'hidden', mb: 2, ...sx }}>
//     <Box
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         px: 2.5,
//         py: 1.5,
//         bgcolor: '#fafbfc',
//         flexWrap: 'wrap',
//         gap: 1,
//       }}
//     >
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
//         {icon && (
//           <Avatar variant="rounded" sx={{ width: 36, height: 36, bgcolor: C.indigo, color: '#fff', flexShrink: 0 }}>
//             {icon}
//           </Avatar>
//         )}
//         <Typography variant="body1" fontWeight={700} noWrap>
//           {title}
//         </Typography>
//       </Box>
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//         {badge}
//       </Box>
//     </Box>
//     <Box sx={{ p: 2.5 }}>{children}</Box>
//   </Box>
// );

// /* ----------------------------------------------------------------------
//    Main Component
// ---------------------------------------------------------------------- */
// const CreateBusiness = ({ business, isEditMode = false, onSuccess }) => {
//   const navigate = useNavigate();
//   const [loading, setLoading] = React.useState(false);
//   const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'error' });

//   const showSnackbar = (message, severity = 'error') =>
//     setSnackbar({ open: true, message, severity });

//   const formik = useFormik({
//     initialValues: {
//       businessName: '',
//       industry: '',
//       contactEmail: '',
//       emergencyContactNo: '',
//       websiteUrl: '',
//       webhookUrl: '',
//       accountStatus: BUSINESS_STATUS.ACTIVE,
//     },
//     validationSchema,
//     onSubmit: async (values) => {
//       try {
//         setLoading(true);
//         if (isEditMode) {
//           await adminService.updateBusiness(business._id, values);
//           showSnackbar('Business updated!', 'success');
//         } else {
//           await adminService.createBusiness(values);
//           showSnackbar('Business created!', 'success');
//         }
//         setTimeout(() => onSuccess?.(), 1000);
//       } catch (err) {
//         showSnackbar(err.message || 'Something went wrong');
//       } finally {
//         setLoading(false);
//       }
//     },
//   });

//   const { values, handleChange, handleBlur, setFieldValue, errors, touched } = formik;

//   useEffect(() => {
//     if (!isEditMode || !business) return;
//     formik.setValues({
//       businessName: business.businessName || '',
//       industry: business.industry || '',
//       contactEmail: business.contactEmail || '',
//       emergencyContactNo: business.emergencyContactNo || '',
//       websiteUrl: business.websiteUrl || '',
//       webhookUrl: business.webhookUrl || '',
//       accountStatus: business.accountStatus || BUSINESS_STATUS.ACTIVE,
//     });
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [isEditMode, business?._id]);

//   const isActive = values.accountStatus === BUSINESS_STATUS.ACTIVE;

//   return (
//     <Container maxWidth={false} sx={{ py: 3, px: { xs: 2, sm: 3, md: 5 } }}>
//       {/* HEADER */}
//       <Box sx={{ mb: 3 }}>
//         <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
//           <MuiLink
//             underline="hover"
//             color="text.secondary"
//             href="#"
//             onClick={(e) => {
//               e.preventDefault();
//               navigate('/admin/businesses');
//             }}
//           >
//             Businesses
//           </MuiLink>
//           <Typography color="text.primary" fontSize={13} fontWeight={600}>
//             {isEditMode ? 'Edit Business' : 'Create Business'}
//           </Typography>
//         </Breadcrumbs>

//         <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
//           <Typography variant="h5" fontWeight={800} sx={{ color: C.textPrimary, fontSize: { xs: 24, md: 28 } }}>
//             {isEditMode ? 'Edit Business' : 'Create New Business'}
//           </Typography>
//           <Typography variant="body2" color="text.secondary" sx={{ fontSize: 15 }}>
//             {isEditMode ? 'Update business information' : 'Add a new business account'}
//           </Typography>
//         </Box>
//       </Box>

//       {/* MAIN LAYOUT – left form + right preview */}
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: { xs: 'column', md: 'row' },
//           alignItems: 'flex-start',
//           gap: 3,
//         }}
//       >
//         {/* LEFT – form */}
//         <Box sx={{ flex: '1 1 0%', minWidth: 0, width: '100%' }}>
//           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
//             <form onSubmit={formik.handleSubmit}>
//               {/* Basic Information */}
//               <SectionCard
//                 icon={<BusinessIcon fontSize="small" />}
//                 title="Business Details"
//                 badge={<StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} />}
//               >
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
//                   <Box>
//                     <FieldLabel>Business Name *</FieldLabel>
//                     <TextField
//                       fullWidth
//                       size="medium"
//                       name="businessName"
//                       placeholder="Enter business name"
//                       value={values.businessName}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.businessName && Boolean(errors.businessName)}
//                       helperText={touched.businessName && errors.businessName}
//                     />
//                   </Box>

//                   <Box>
//                     <FieldLabel>Industry *</FieldLabel>
//                     <FormControl fullWidth size="medium" error={touched.industry && Boolean(errors.industry)}>
//                       <Select
//                         name="industry"
//                         displayEmpty
//                         value={values.industry}
//                         onChange={handleChange}
//                         onBlur={handleBlur}
//                       >
//                         <MenuItem value="" disabled>Select industry</MenuItem>
//                         {INDUSTRIES.map((i) => (
//                           <MenuItem key={i} value={i}>{i}</MenuItem>
//                         ))}
//                       </Select>
//                       {touched.industry && errors.industry && (
//                         <FormHelperText error>{errors.industry}</FormHelperText>
//                       )}
//                     </FormControl>
//                   </Box>

//                   <Box>
//                     <FieldLabel>Contact Email *</FieldLabel>
//                     <TextField
//                       fullWidth
//                       size="medium"
//                       type="email"
//                       name="contactEmail"
//                       placeholder="business@example.com"
//                       value={values.contactEmail}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.contactEmail && Boolean(errors.contactEmail)}
//                       helperText={touched.contactEmail && errors.contactEmail}
//                     />
//                   </Box>

//                   <Box>
//                     <FieldLabel>Emergency Contact *</FieldLabel>
//                     <TextField
//                       fullWidth
//                       size="medium"
//                       name="emergencyContactNo"
//                       placeholder="Digits only, e.g. 9198765432"
//                       value={values.emergencyContactNo}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.emergencyContactNo && Boolean(errors.emergencyContactNo)}
//                       helperText={touched.emergencyContactNo && errors.emergencyContactNo}
//                     />
//                   </Box>

//                   <Box>
//                     <FieldLabel>Website URL *</FieldLabel>
//                     <TextField
//                       fullWidth
//                       size="medium"
//                       type="url"
//                       name="websiteUrl"
//                       placeholder="https://example.com"
//                       value={values.websiteUrl}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.websiteUrl && Boolean(errors.websiteUrl)}
//                       helperText={touched.websiteUrl && errors.websiteUrl}
//                     />
//                   </Box>

//                   <Box>
//                     <FieldLabel>Webhook URL *</FieldLabel>
//                     <TextField
//                       fullWidth
//                       size="medium"
//                       name="webhookUrl"
//                       placeholder="https://example.com/webhook"
//                       value={values.webhookUrl}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.webhookUrl && Boolean(errors.webhookUrl)}
//                       helperText={touched.webhookUrl && errors.webhookUrl}
//                     />
//                   </Box>
//                 </Box>
//               </SectionCard>

//               {/* Access & Status */}
//               <SectionCard
//                 icon={<LockIcon fontSize="small" />}
//                 title="Access & Status"
//                 badge={<StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} />}
//               >
//                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
//                   <Box>
//                     <FieldLabel>Account Status *</FieldLabel>
//                     <FormControl fullWidth size="medium" error={touched.accountStatus && Boolean(errors.accountStatus)}>
//                       <Select name="accountStatus" value={values.accountStatus} onChange={handleChange}>
//                         {Object.values(BUSINESS_STATUS).map((s) => (
//                           <MenuItem key={s} value={s}>{s}</MenuItem>
//                         ))}
//                       </Select>
//                       {touched.accountStatus && errors.accountStatus && (
//                         <FormHelperText error>{errors.accountStatus}</FormHelperText>
//                       )}
//                     </FormControl>
//                   </Box>

//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                     <Switch
//                       checked={isActive}
//                       onChange={(e) =>
//                         setFieldValue(
//                           'accountStatus',
//                           e.target.checked ? BUSINESS_STATUS.ACTIVE : BUSINESS_STATUS.INACTIVE
//                         )
//                       }
//                       color="primary"
//                     />
//                     <Typography variant="body2" color="text.secondary">
//                       {isActive ? 'Business will be active' : 'Business will be inactive'}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </SectionCard>

//               {/* FOOTER ACTIONS */}
//               <Box
//                 sx={{
//                   display: 'flex',
//                   justifyContent: 'space-between',
//                   alignItems: 'center',
//                   mt: 4,
//                   pt: 3,
//                   borderTop: `1px solid ${C.border}`,
//                 }}
//               >
//                 <Button
//                   variant="outlined"
//                   startIcon={<ArrowBackIcon />}
//                   onClick={() => navigate('/admin/businesses')}
//                   disabled={loading}
//                   sx={{ borderColor: C.border, color: C.textPrimary, px: 3, py: 1 }}
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   variant="contained"
//                   onClick={formik.handleSubmit}
//                   disabled={loading}
//                   endIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CheckCircle />}
//                   sx={{
//                     background: `#2563EB`,
//                     color: '#fff',
//                     px: 5,
//                     py: 1.5,
//                   }}
//                 >
//                   {loading ? 'Processing…' : isEditMode ? 'Update Business' : 'Create Business'}
//                 </Button>
//               </Box>
//             </form>
//           </Paper>
//         </Box>

//         {/* RIGHT – preview sidebar (sticky) */}
//         <Box
//           sx={{
//             flex: '0 0 auto',
//             width: { xs: '100%', md: 520 },
//             position: { md: 'sticky' },
//             top: { md: 16 },
//           }}
//         >
//           <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
//             <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
//               Business Preview
//             </Typography>

//             <Box
//               sx={{
//                 border: `1px solid ${C.border}`,
//                 borderRadius: 2,
//                 p: 3,
//                 textAlign: 'center',
//                 mb: 2.5,
//               }}
//             >
//               <Box
//                 sx={{
//                   width: 88,
//                   height: 88,
//                   borderRadius: '50%',
//                   bgcolor: C.indigo,
//                   color: '#fff',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: 28,
//                   fontWeight: 700,
//                   mx: 'auto',
//                   mb: 1.5,
//                   overflow: 'hidden',
//                 }}
//               >
//                 {values.businessName ? (
//                   values.businessName.slice(0, 2).toUpperCase()
//                 ) : (
//                   <BusinessIcon sx={{ fontSize: 34 }} />
//                 )}
//               </Box>
//               <Typography variant="h6" fontWeight={700}>
//                 {values.businessName || 'Business Name'}
//               </Typography>
//               {values.industry && (
//                 <Chip
//                   label={values.industry}
//                   size="small"
//                   sx={{ bgcolor: C.badgeActiveBg, color: C.badgeActiveText, fontWeight: 600, my: 1 }}
//                 />
//               )}
//               <Typography variant="body2" color="text.secondary">
//                 {values.contactEmail || 'business@example.com'}
//               </Typography>
//             </Box>

//             <Typography variant="subtitle2" fontWeight={700} color={C.blue} sx={{ mb: 1.5 }}>
//               Overview
//             </Typography>
//             <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, p: 2 }}>
//               {[
//                 ['Website', values.websiteUrl || '-'],
//                 ['Webhook', values.webhookUrl || '-'],
//                 ['Emergency Contact', values.emergencyContactNo || '-'],
//               ].map(([label, value]) => (
//                 <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6, gap: 2 }}>
//                   <Typography variant="body2" color="text.secondary">{label}</Typography>
//                   <Typography variant="body2" fontWeight={600} sx={{ textAlign: 'right', wordBreak: 'break-all' }}>
//                     {value}
//                   </Typography>
//                 </Box>
//               ))}
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6 }}>
//                 <Typography variant="body2" color="text.secondary">Status</Typography>
//                 <StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} />
//               </Box>
//             </Box>

//             <Box
//               sx={{
//                 mt: 2.5,
//                 bgcolor: C.infoBg,
//                 border: `1px solid ${C.infoBorder}`,
//                 borderRadius: 2,
//                 p: 2,
//                 display: 'flex',
//                 gap: 1.5,
//               }}
//             >
//               <InfoOutlined sx={{ color: C.infoText, fontSize: 20, mt: 0.2 }} />
//               <Box>
//                 <Typography variant="body2" fontWeight={700} sx={{ color: C.infoText }}>
//                   Good to know
//                 </Typography>
//                 <Typography variant="caption" sx={{ color: C.infoText }}>
//                   Domains and white-label branding are configured separately, from the business's
//                   detail page, after the business has been created.
//                 </Typography>
//               </Box>
//             </Box>
//           </Paper>
//         </Box>
//       </Box>

//       {/* SNACKBAR */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
//         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//       >
//         <Alert
//           severity={snackbar.severity}
//           variant="filled"
//           onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
//           action={
//             <IconButton size="small" color="inherit" onClick={() => setSnackbar((s) => ({ ...s, open: false }))}>
//               <CloseIcon fontSize="small" />
//             </IconButton>
//           }
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Container>
//   );
// };

// export default CreateBusiness;

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTheme, alpha, lighten } from '@mui/material/styles';
import {
  Container,
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  IconButton,
  Alert,
  CircularProgress,
  Paper,
  Breadcrumbs,
  Link as MuiLink,
  Chip,
  FormHelperText,
  Snackbar,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  CheckCircle,
  Business as BusinessIcon,
  InfoOutlined,
  Close as CloseIcon,
  Lock as LockIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { adminService } from '../../services/admin';
import { BUSINESS_STATUS } from '../../utils/constants';
import useFormPersist from '../../hooks/useFormPersist';

// Storage key for the "Create Business" draft (see useFormPersist). Only used
// in create mode — edit mode loads the real record instead.
const BUSINESS_DRAFT_KEY = 'goflipo:draft:create-business';

/* ----------------------------------------------------------------------
   Design tokens – consistent with CreateApplicationPage. Derived from the
   active theme so this reads correctly in both light and dark mode,
   instead of a fixed light-only palette.
---------------------------------------------------------------------- */
const getTokens = (theme) => {
  const isDark = theme.palette.mode === 'dark';
  return {
    border: theme.palette.divider,
    blue: theme.palette.primary.main,
    blueDark: theme.palette.primary.dark,
    green: theme.palette.success.main,
    greenDark: theme.palette.success.dark,
    indigo: theme.palette.secondary.main,
    textPrimary: theme.palette.text.primary,
    textSecondary: theme.palette.text.secondary,
    bgLight: isDark ? alpha(theme.palette.common.white, 0.04) : '#f7fafc',
    badgeActiveBg: alpha(theme.palette.success.main, isDark ? 0.22 : 0.15),
    badgeActiveText: isDark ? lighten(theme.palette.success.main, 0.4) : theme.palette.success.dark,
    badgeInactiveBg: isDark ? alpha(theme.palette.common.white, 0.08) : theme.palette.divider,
    badgeInactiveText: theme.palette.text.secondary,
    badgeBlockedBg: alpha(theme.palette.error.main, isDark ? 0.22 : 0.15),
    badgeBlockedText: isDark ? lighten(theme.palette.error.main, 0.4) : theme.palette.error.dark,
    infoBg: alpha(theme.palette.info.main, isDark ? 0.18 : 0.1),
    infoBorder: alpha(theme.palette.info.main, isDark ? 0.4 : 0.3),
    infoText: isDark ? lighten(theme.palette.info.main, 0.35) : theme.palette.info.dark,
  };
};

const INDUSTRIES = [
  'Technology', 'Finance', 'Healthcare', 'Retail', 'Education',
  'Manufacturing', 'Real Estate', 'Hospitality', 'Transportation', 'Other',
];

/* ----------------------------------------------------------------------
   Validation schema (unchanged)
---------------------------------------------------------------------- */
const validationSchema = Yup.object({
  businessName: Yup.string()
    .required('Business Name is required')
    .min(2, 'Business Name must be at least 2 characters')
    .max(100),
  industry: Yup.string().required('Industry is required'),
  contactEmail: Yup.string().email('Invalid email').required('Contact Email is required'),
  emergencyContactNo: Yup.string()
    .matches(/^[0-9]+$/, 'Only digits allowed')
    .min(7, 'Min 7 digits')
    .max(15, 'Max 15 digits')
    .required('Emergency Contact is required'),
  websiteUrl: Yup.string().url('Enter a valid URL').required('Website URL is required'),
  webhookUrl: Yup.string().url('Enter a valid URL'),
  accountStatus: Yup.string().required('Account Status is required'),
});

/* ----------------------------------------------------------------------
   Reusable UI components – shared with CreateApplicationPage
---------------------------------------------------------------------- */
const StatusBadge = ({ active, label, C, blocked = false }) => (
  <Chip
    label={label}
    size="small"
    sx={{
      fontWeight: 700,
      fontSize: 11,
      height: 22,
      bgcolor: blocked ? C.badgeBlockedBg : active ? C.badgeActiveBg : C.badgeInactiveBg,
      color: blocked ? C.badgeBlockedText : active ? C.badgeActiveText : C.badgeInactiveText,
    }}
  />
);

const FieldLabel = ({ children }) => (
  <Typography variant="body2" fontWeight={600} sx={{ mb: 0.75 }}>
    {children}
  </Typography>
);

const SectionCard = ({ icon, title, badge, children, sx, C }) => (
  <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, overflow: 'hidden', mb: 2, ...sx }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 2.5,
        py: 1.5,
        bgcolor: C.bgLight,
        flexWrap: 'wrap',
        gap: 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}>
        {icon && (
          <Avatar variant="rounded" sx={{ width: 36, height: 36, bgcolor: C.indigo, color: '#fff', flexShrink: 0 }}>
            {icon}
          </Avatar>
        )}
        <Typography variant="body1" fontWeight={700} noWrap>
          {title}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {badge}
      </Box>
    </Box>
    <Box sx={{ p: 2.5 }}>{children}</Box>
  </Box>
);

/* ----------------------------------------------------------------------
   Main Component
---------------------------------------------------------------------- */
const CreateBusiness = ({ business, isEditMode = false, onSuccess }) => {
  const theme = useTheme();
  const C = getTokens(theme);
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'error' });

  const showSnackbar = (message, severity = 'error') =>
    setSnackbar({ open: true, message, severity });

  const formik = useFormik({
    initialValues: {
      businessName: '',
      industry: '',
      contactEmail: '',
      emergencyContactNo: '',
      websiteUrl: '',
      webhookUrl: '',
      accountStatus: BUSINESS_STATUS.ACTIVE,
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        if (isEditMode) {
          await adminService.updateBusiness(business._id, values);
          // Block/unblock only takes effect here, on actual save — not when
          // the confirmation dialog was answered — so Cancel-ing the form
          // afterwards never leaves a block/unblock applied on the server.
          if (pendingBlockChange?.action === 'block') {
            await adminService.blockBusiness(business._id, pendingBlockChange.reason);
          } else if (pendingBlockChange?.action === 'unblock') {
            await adminService.unblockBusiness(business._id, pendingBlockChange.reason);
          }
          setPendingBlockChange(null);
          showSnackbar('Business updated!', 'success');
        } else {
          await adminService.createBusiness(values);
          // Business saved — the draft has served its purpose, discard it so
          // the next "Create Business" starts blank.
          try { sessionStorage.removeItem(BUSINESS_DRAFT_KEY); } catch {}
          showSnackbar('Business created!', 'success');
        }
        setTimeout(() => onSuccess?.(), 1000);
      } catch (err) {
        showSnackbar(err.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    },
  });

  const { values, handleChange, handleBlur, setFieldValue, errors, touched } = formik;

  // Auto-save the form so a refresh / navigating away doesn't lose input.
  // Disabled in edit mode (that form is populated from the real record).
  const { clearDraft, restored } = useFormPersist(BUSINESS_DRAFT_KEY, formik, {
    enabled: !isEditMode,
  });

  useEffect(() => {
    if (!isEditMode || !business) return;
    formik.setValues({
      businessName: business.businessName || '',
      industry: business.industry || '',
      contactEmail: business.contactEmail || '',
      emergencyContactNo: business.emergencyContactNo || '',
      websiteUrl: business.websiteUrl || '',
      webhookUrl: business.webhookUrl || '',
      accountStatus: business.accountStatus || BUSINESS_STATUS.ACTIVE,
    });
    setIsBlocked(Boolean(business.blockDetails?.isBlocked));
    setPendingBlockChange(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditMode, business?._id]);

  const isActive = values.accountStatus === BUSINESS_STATUS.ACTIVE;

  // Block state is tracked locally (seeded from business.blockDetails.isBlocked
  // above) so that blocking/unblocking from this page updates the dropdown and
  // badges immediately, without needing the parent to refetch the business.
  const [isBlocked, setIsBlocked] = React.useState(Boolean(business?.blockDetails?.isBlocked));

  // Block/unblock confirmation — mirrors the same reason-required flow used
  // on the Businesses list (adminService.blockBusiness/unblockBusiness), just
  // triggered from the Account Status dropdown instead of a row action.
  // Answering the dialog only STAGES the change (pendingBlockChange) — the
  // block/unblock API call itself only fires from onSubmit, when the user
  // actually clicks "Update Business". That way hitting Cancel afterwards
  // (or just navigating away) never leaves a block/unblock applied that the
  // rest of the form's edits were never saved for.
  const [blockDialog, setBlockDialog] = React.useState(null); // { action: 'block'|'unblock', nextStatus? }
  const [blockReason, setBlockReason] = React.useState('');
  const [pendingBlockChange, setPendingBlockChange] = React.useState(null); // { action, reason } | null
  const [previewOpen, setPreviewOpen] = React.useState(false);

  const selectAccountStatus = (next) => {
    if (next === BUSINESS_STATUS.BLOCKED) {
      if (isBlocked) return;
      setBlockReason('');
      setBlockDialog({ action: 'block' });
    } else if (isBlocked) {
      // Currently blocked (or staged to become blocked) and picking
      // Active/Inactive — that requires unblocking first, so confirm it the
      // same way the list does.
      setBlockReason('');
      setBlockDialog({ action: 'unblock', nextStatus: next });
    } else {
      setFieldValue('accountStatus', next);
    }
  };

  const handleBlockDialogConfirm = () => {
    if (!blockDialog || !blockReason.trim()) return;
    const reason = blockReason.trim();
    if (blockDialog.action === 'block') {
      setIsBlocked(true);
      setPendingBlockChange({ action: 'block', reason });
    } else {
      setIsBlocked(false);
      setFieldValue('accountStatus', blockDialog.nextStatus || BUSINESS_STATUS.ACTIVE);
      setPendingBlockChange({ action: 'unblock', reason });
    }
    setBlockDialog(null);
    setBlockReason('');
  };

  // The Industry select only renders MenuItems for the fixed INDUSTRIES list;
  // MUI's controlled Select shows nothing selected if `value` doesn't match
  // one of them exactly. A business saved with an industry outside that list
  // (legacy data, or added directly via API) would then look blank in Edit
  // even though formik.values.industry is correct — so make sure the
  // business's actual current value always has a matching option.
  const industryOptions = React.useMemo(() => {
    if (values.industry && !INDUSTRIES.includes(values.industry)) {
      return [...INDUSTRIES, values.industry];
    }
    return INDUSTRIES;
  }, [values.industry]);

  // BLOCKED only makes sense once a business exists to block/unblock (edit
  // mode) — accountStatus itself still only ever stores ACTIVE/INACTIVE;
  // selecting BLOCKED routes through the confirmation dialog above instead
  // of being written directly to that field.
  const accountStatusOptions = isEditMode
    ? [BUSINESS_STATUS.ACTIVE, BUSINESS_STATUS.INACTIVE, BUSINESS_STATUS.BLOCKED]
    : [BUSINESS_STATUS.ACTIVE, BUSINESS_STATUS.INACTIVE];

  const accountStatusDisplayValue = isBlocked ? BUSINESS_STATUS.BLOCKED : values.accountStatus;

  return (
    <Container maxWidth={false} sx={{ py: 3, px: { xs: 2, sm: 3, md: 5 } }}>
      {/* HEADER */}
      <Box sx={{ mb: 3, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
        <Box>
          <Breadcrumbs sx={{ mb: 0.5, fontSize: 13 }}>
            <MuiLink
              underline="hover"
              color="text.secondary"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                navigate('/admin/businesses');
              }}
            >
              Businesses
            </MuiLink>
            <Typography color="text.primary" fontSize={13} fontWeight={600}>
              {isEditMode ? 'Edit Business' : 'Create Business'}
            </Typography>
          </Breadcrumbs>

          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1.5, flexWrap: 'wrap' }}>
            <Typography variant="h5" fontWeight={800} sx={{ color: C.textPrimary, fontSize: { xs: 24, md: 28 } }}>
              {isEditMode ? 'Edit Business' : 'Create New Business'}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: 15 }}>
              {isEditMode ? 'Update business information' : 'Add a new business account'}
            </Typography>
          </Box>
        </Box>

        <Button
          variant="outlined"
          startIcon={<VisibilityIcon />}
          onClick={() => setPreviewOpen(true)}
          sx={{ borderColor: C.blue, color: C.blue, fontWeight: 600, px: 2.5, flexShrink: 0 }}
        >
          Preview
        </Button>
      </Box>

      {/* Draft restored notice — only in create mode when a saved draft was loaded */}
      {!isEditMode && restored && (
        <Alert
          severity="info"
          sx={{ mb: 2 }}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                formik.resetForm();
                clearDraft();
              }}
            >
              Start fresh
            </Button>
          }
        >
          We restored the details you entered earlier.
        </Alert>
      )}

      {/* MAIN LAYOUT – form */}
      <Box sx={{ width: '100%' }}>
        <Box sx={{ width: '100%' }}>
          <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${C.border}`, p: 3 }}>
            <form onSubmit={formik.handleSubmit}>
              {/* Basic Information */}
              <SectionCard
                icon={<BusinessIcon fontSize="small" />}
                title="Business Details"
                badge={
                  isBlocked ? (
                    <StatusBadge active={false} blocked label="BLOCKED" C={C} />
                  ) : (
                    <StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} C={C} />
                  )
                }
                C={C}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                  <Box>
                    <FieldLabel>Business Name *</FieldLabel>
                    <TextField
                      fullWidth
                      size="medium"
                      name="businessName"
                      placeholder="Enter business name"
                      value={values.businessName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={isEditMode}
                      error={touched.businessName && Boolean(errors.businessName)}
                      helperText={
                        (touched.businessName && errors.businessName) ||
                        (isEditMode ? "Business name can't be changed after creation." : undefined)
                      }
                      sx={{
                        '& .MuiInputBase-input.Mui-disabled': {
                          WebkitTextFillColor: C.textPrimary,
                          color: C.textPrimary,
                        },
                        '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
                          borderColor: C.border,
                        },
                      }}
                    />
                  </Box>

                  <Box>
                    <FieldLabel>Industry *</FieldLabel>
                    <FormControl fullWidth size="medium" error={touched.industry && Boolean(errors.industry)}>
                      <Select
                        name="industry"
                        displayEmpty
                        value={values.industry}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="" disabled>Select industry</MenuItem>
                        {industryOptions.map((i) => (
                          <MenuItem key={i} value={i}>{i}</MenuItem>
                        ))}
                      </Select>
                      {touched.industry && errors.industry && (
                        <FormHelperText error>{errors.industry}</FormHelperText>
                      )}
                    </FormControl>
                  </Box>

                  <Box>
                    <FieldLabel>Contact Email *</FieldLabel>
                    <TextField
                      fullWidth
                      size="medium"
                      type="email"
                      name="contactEmail"
                      placeholder="business@example.com"
                      value={values.contactEmail}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      disabled={isEditMode}
                      error={touched.contactEmail && Boolean(errors.contactEmail)}
                      helperText={
                        (touched.contactEmail && errors.contactEmail) ||
                        (isEditMode ? "Contact email can't be changed after creation." : undefined)
                      }
                      sx={{
                        '& .MuiInputBase-input.Mui-disabled': {
                          WebkitTextFillColor: C.textPrimary,
                          color: C.textPrimary,
                        },
                        '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
                          borderColor: C.border,
                        },
                      }}
                    />
                  </Box>

                  <Box>
                    <FieldLabel>Emergency Contact *</FieldLabel>
                    <TextField
                      fullWidth
                      size="medium"
                      name="emergencyContactNo"
                      placeholder="Digits only, e.g. 9198765432"
                      value={values.emergencyContactNo}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.emergencyContactNo && Boolean(errors.emergencyContactNo)}
                      helperText={touched.emergencyContactNo && errors.emergencyContactNo}
                    />
                  </Box>

                  <Box>
                    <FieldLabel>Website URL *</FieldLabel>
                    <TextField
                      fullWidth
                      size="medium"
                      type="url"
                      name="websiteUrl"
                      placeholder="https://example.com"
                      value={values.websiteUrl}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.websiteUrl && Boolean(errors.websiteUrl)}
                      helperText={touched.websiteUrl && errors.websiteUrl}
                    />
                  </Box>

                  <Box>
                    <FieldLabel>Webhook URL (optional)</FieldLabel>
                    <TextField
                      fullWidth
                      size="medium"
                      name="webhookUrl"
                      placeholder="https://example.com/webhook"
                      value={values.webhookUrl}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.webhookUrl && Boolean(errors.webhookUrl)}
                      helperText={touched.webhookUrl && errors.webhookUrl}
                    />
                  </Box>
                </Box>
              </SectionCard>

              {/* Access & Status */}
              <SectionCard
                icon={<LockIcon fontSize="small" />}
                title="Access & Status"
                badge={
                  isBlocked ? (
                    <StatusBadge active={false} blocked label="BLOCKED" C={C} />
                  ) : (
                    <StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} C={C} />
                  )
                }
                C={C}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                  <Box>
                    <FieldLabel>Account Status *</FieldLabel>
                    <FormControl fullWidth size="medium" error={touched.accountStatus && Boolean(errors.accountStatus)}>
                      <Select
                        name="accountStatus"
                        // The real accountStatus field only ever holds ACTIVE/INACTIVE, but the
                        // dropdown itself should always show what's actually true right now —
                        // BLOCKED when blocked — so the displayed value is derived from the
                        // block state, not read directly off formik.
                        value={accountStatusDisplayValue}
                        onChange={(e) => selectAccountStatus(e.target.value)}
                        sx={
                          isBlocked
                            ? {
                                bgcolor: C.badgeBlockedBg,
                                '& .MuiSelect-select': { color: C.badgeBlockedText, fontWeight: 700 },
                                '& .MuiOutlinedInput-notchedOutline': { borderColor: C.badgeBlockedText },
                              }
                            : undefined
                        }
                      >
                        {accountStatusOptions.map((s) => (
                          <MenuItem key={s} value={s}>{s}</MenuItem>
                        ))}
                      </Select>
                      {touched.accountStatus && errors.accountStatus ? (
                        <FormHelperText error>{errors.accountStatus}</FormHelperText>
                      ) : (
                        <FormHelperText>
                          {isBlocked
                            ? 'This business is blocked. Choose Active or Inactive to unblock it.'
                            : isEditMode
                            ? 'Choosing Blocked here will block this business.'
                            : ''}
                        </FormHelperText>
                      )}
                    </FormControl>
                  </Box>
                </Box>
              </SectionCard>

              {/* FOOTER ACTIONS */}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column-reverse', sm: 'row' },
                  justifyContent: 'space-between',
                  alignItems: { xs: 'stretch', sm: 'center' },
                  gap: { xs: 1.5, sm: 0 },
                  mt: 4,
                  pt: 3,
                  borderTop: `1px solid ${C.border}`,
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<ArrowBackIcon />}
                  onClick={() => navigate('/admin/businesses')}
                  disabled={loading}
                  fullWidth={false}
                  sx={{ borderColor: C.border, color: C.textPrimary, px: 3, py: 1, width: { xs: '100%', sm: 'auto' } }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={formik.handleSubmit}
                  disabled={loading}
                  endIcon={loading ? <CircularProgress size={20} color="inherit" /> : <CheckCircle />}
                  sx={{
                    background: `#2563EB`,
                    color: '#fff',
                    px: 5,
                    py: 1.5,
                    width: { xs: '100%', sm: 'auto' },
                  }}
                >
                  {loading ? 'Processing…' : isEditMode ? 'Update Business' : 'Create Business'}
                </Button>
              </Box>
            </form>
          </Paper>
        </Box>
      </Box>

      {/* PREVIEW DIALOG */}
      <Dialog
        open={previewOpen}
        onClose={() => setPreviewOpen(false)}
        maxWidth="sm"
        fullWidth
        fullScreen={isXs}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Business Preview
          <IconButton size="small" onClick={() => setPreviewOpen(false)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box
            sx={{
              border: `1px solid ${C.border}`,
              borderRadius: 2,
              p: 3,
              textAlign: 'center',
              mb: 2.5,
            }}
          >
            <Box
              sx={{
                width: 88,
                height: 88,
                borderRadius: '50%',
                bgcolor: C.indigo,
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 28,
                fontWeight: 700,
                mx: 'auto',
                mb: 1.5,
                overflow: 'hidden',
              }}
            >
              {values.businessName ? (
                values.businessName.slice(0, 2).toUpperCase()
              ) : (
                <BusinessIcon sx={{ fontSize: 34 }} />
              )}
            </Box>
            <Typography variant="h6" fontWeight={700}>
              {values.businessName || 'Business Name'}
            </Typography>
            {values.industry && (
              <Chip
                label={values.industry}
                size="small"
                sx={{ bgcolor: C.badgeActiveBg, color: C.badgeActiveText, fontWeight: 600, my: 1 }}
              />
            )}
            <Typography variant="body2" color="text.secondary">
              {values.contactEmail || 'business@example.com'}
            </Typography>
          </Box>

          <Typography variant="subtitle2" fontWeight={700} color={C.blue} sx={{ mb: 1.5 }}>
            Overview
          </Typography>
          <Box sx={{ border: `1px solid ${C.border}`, borderRadius: 2, p: 2 }}>
            {[
              ['Website', values.websiteUrl || '-'],
              ['Webhook', values.webhookUrl || '-'],
              ['Emergency Contact', values.emergencyContactNo || '-'],
            ].map(([label, value]) => (
              <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6, gap: 2 }}>
                <Typography variant="body2" color="text.secondary">{label}</Typography>
                <Typography variant="body2" fontWeight={600} sx={{ textAlign: 'right', wordBreak: 'break-all' }}>
                  {value}
                </Typography>
              </Box>
            ))}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', py: 0.6 }}>
              <Typography variant="body2" color="text.secondary">Status</Typography>
              {isBlocked ? (
                <StatusBadge active={false} blocked label="BLOCKED" C={C} />
              ) : (
                <StatusBadge active={isActive} label={isActive ? 'ACTIVE' : 'INACTIVE'} C={C} />
              )}
            </Box>
          </Box>

          <Box
            sx={{
              mt: 2.5,
              bgcolor: C.infoBg,
              border: `1px solid ${C.infoBorder}`,
              borderRadius: 2,
              p: 2,
              display: 'flex',
              gap: 1.5,
            }}
          >
            <InfoOutlined sx={{ color: C.infoText, fontSize: 20, mt: 0.2 }} />
            <Box>
              <Typography variant="body2" fontWeight={700} sx={{ color: C.infoText }}>
                Good to know
              </Typography>
              <Typography variant="caption" sx={{ color: C.infoText }}>
                Domains and white-label branding are configured separately, from the business's
                detail page, after the business has been created.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPreviewOpen(false)} variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* SNACKBAR */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
          action={
            <IconButton size="small" color="inherit" onClick={() => setSnackbar((s) => ({ ...s, open: false }))}>
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* BLOCK / UNBLOCK CONFIRMATION */}
      <Dialog
        open={!!blockDialog}
        onClose={() => setBlockDialog(null)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {blockDialog?.action === 'block' ? 'Block Business' : 'Unblock Business'}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, mt: 1 }}>
            Are you sure you want to {blockDialog?.action}{' '}
            <strong>{values.businessName || 'this business'}</strong>? This will be applied when
            you click "Update Business" below — it won't take effect if you cancel instead.
          </Typography>
          <TextField
            autoFocus
            label={blockDialog?.action === 'block' ? 'Block Reason' : 'Unblock Reason'}
            fullWidth
            multiline
            rows={3}
            value={blockReason}
            onChange={(e) => setBlockReason(e.target.value)}
            placeholder={
              blockDialog?.action === 'block'
                ? 'Please provide a reason for blocking...'
                : 'Please provide a reason for unblocking...'
            }
            required
            error={blockReason.trim() === ''}
            helperText={blockReason.trim() === '' ? 'Reason is required' : ''}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBlockDialog(null)}>
            Cancel
          </Button>
          <Button
            onClick={handleBlockDialogConfirm}
            color={blockDialog?.action === 'block' ? 'error' : 'primary'}
            variant="contained"
            disabled={!blockReason.trim()}
          >
            {blockDialog?.action === 'block' ? 'Block' : 'Unblock'}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CreateBusiness;